function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3067"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3067"] = parcelRequire;
}
parcelRequire.register("hP7ZM", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("fkHR7"))(new URL((parcelRequire("l0sc7")).resolve("f46zc"), import.meta.url).toString()),
    import("./" + (parcelRequire("l0sc7")).resolve("aFdd4"))
]).then(()=>parcelRequire("hUqjE"));

});
parcelRequire.register("fkHR7", function(module, exports) {
"use strict";

var $kb7DA = parcelRequire("kb7DA");
module.exports = $kb7DA(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});
parcelRequire.register("kb7DA", function(module, exports) {
"use strict";
var $eb0ac264c4f50c58$var$cachedBundles = {};
var $eb0ac264c4f50c58$var$cachedPreloads = {};
var $eb0ac264c4f50c58$var$cachedPrefetches = {};
function $eb0ac264c4f50c58$var$getCache(type) {
    switch(type){
        case "preload":
            return $eb0ac264c4f50c58$var$cachedPreloads;
        case "prefetch":
            return $eb0ac264c4f50c58$var$cachedPrefetches;
        default:
            return $eb0ac264c4f50c58$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $eb0ac264c4f50c58$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRequire.register("gfJak", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("fkHR7"))(new URL((parcelRequire("l0sc7")).resolve("8e7ig"), import.meta.url).toString()),
    import("./" + (parcelRequire("l0sc7")).resolve("7GHro"))
]).then(()=>parcelRequire("aYtW6"));

});

parcelRequire.register("MlfZd", function(module, exports) {

module.exports = import("./" + (parcelRequire("l0sc7")).resolve("kvVtu")).then(()=>parcelRequire("e21Yh"));

});

parcelRequire.register("8tysl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $a4962d69d60c0f87$export$2e2bcd8739ae039; });

var $iIzY2 = parcelRequire("iIzY2");

var $hDoNm = parcelRequire("hDoNm");

var $jfoP4 = parcelRequire("jfoP4");

var $2z5fq = parcelRequire("2z5fq");

var $bzYqW = parcelRequire("bzYqW");

var $aqSUB = parcelRequire("aqSUB");

var $dZh2E = parcelRequire("dZh2E");

var $8uJrH = parcelRequire("8uJrH");

var $2GVJN = parcelRequire("2GVJN");

var $8d2e7 = parcelRequire("8d2e7");

var $gw6wT = parcelRequire("gw6wT");

var $85kpP = parcelRequire("85kpP");

var $hq03y = parcelRequire("hq03y");

var $aaBFb = parcelRequire("aaBFb");

var $7eFUb = parcelRequire("7eFUb");

var $aKWFw = parcelRequire("aKWFw");

var $4FjZA = parcelRequire("4FjZA");

var $lJLdg = parcelRequire("lJLdg");











var $a4962d69d60c0f87$export$2e2bcd8739ae039 = {
    name: "BaseApp",
    components: {
        ToasterElement: $dZh2E.default,
        WebsocketsElement: $8uJrH.default,
        PwaDialog: $2GVJN.default,
        CustomerView: (0, $iIzY2.defineAsyncComponent)(()=>(parcelRequire("leP4f"))),
        PublicView: (0, $iIzY2.defineAsyncComponent)(()=>(parcelRequire("39vVW"))),
        LoginRegister: (0, $iIzY2.defineAsyncComponent)(()=>(parcelRequire("4HY1I"))),
        BuyerView: (0, $iIzY2.defineAsyncComponent)(()=>(parcelRequire("7pwHo"))),
        RfpForm: (0, $iIzY2.defineAsyncComponent)(()=>(parcelRequire("e2TzR"))),
        UnusedCatsDialog: (0, $iIzY2.defineAsyncComponent)(()=>(parcelRequire("3imCh"))),
        BuyerAppProfile: (0, $iIzY2.defineAsyncComponent)(()=>(parcelRequire("h31e4"))),
        BuyerAppContestPage: (0, $iIzY2.defineAsyncComponent)(()=>(parcelRequire("dwh9B"))),
        ExpressSpreader: (0, $iIzY2.defineAsyncComponent)(()=>(parcelRequire("69Wm8"))),
        MobileBuyerAppPanel: (0, $iIzY2.defineAsyncComponent)(()=>(parcelRequire("9tANg"))),
        ReviewFormPage: (0, $iIzY2.defineAsyncComponent)(()=>(parcelRequire("1O0sq")))
    },
    data () {
        return {
            Module: null,
            Socket: null,
            StateManager: "",
            ServerManager: new (0, $gw6wT.default)(),
            Formatters: new (0, $85kpP.default)(),
            Validators: $hq03y.default,
            Push: null,
            IsLoading: true,
            LoggedUser: {},
            Counters: {},
            IsSaving: false,
            DisplaySavingScreen: true,
            WindowWidth: window.innerWidth,
            Flags: [],
            isDownloadMobileAppTopBarDismissed: window.localStorage.getItem("isDownloadMobileAppTopBarDismissed")
        };
    },
    computed: {
        ...(0, $hDoNm.mapWritableState)((0, $jfoP4.useAppStore), {
            moduleFromStore: "module"
        }),
        ...(0, $hDoNm.mapWritableState)((0, $2z5fq.useUserStore), [
            "loggedAs"
        ]),
        ...(0, $hDoNm.mapWritableState)((0, $jfoP4.useAppStore), [
            "websocketUrl"
        ]),
        ...(0, $hDoNm.mapStores)((0, $jfoP4.useAppStore))
    },
    watch: {
        IsSaving (n) {
            if (n) this.DisplaySavingScreen = true;
            else window.setTimeout(()=>{
                this.DisplaySavingScreen = false;
            }, 150);
        }
    },
    async created () {
        window.addEventListener("resize", ()=>{
            this.WindowWidth = document.body.clientWidth;
        });
        this.Hello();
        document.body.classList.add("is-preloaded");
        window.addEventListener("message", (el)=>{
            const body = document.querySelector("body");
            if (body) {
                if (el.data.signal === "open") body.style.overflowY = "hidden";
                else if (el.data.signal === "close") body.style.overflowY = "scroll";
                else if (el.data.signal === "download-tos") this.DownloadTOSInModal(el.data.TOSPath, el.data.TOSFileName);
            }
        });
        this.AddNavigationListener();
    },
    methods: {
        ...(0, $hDoNm.mapActions)((0, $jfoP4.useAppStore), [
            "hasFlag",
            "addFlag"
        ]),
        ...(0, $hDoNm.mapActions)((0, $bzYqW.useServicesStore), [
            "setNotifications"
        ]),
        ...(0, $hDoNm.mapActions)((0, $4FjZA.useCustomerOnboardingStore), [
            "canShowOnboarding"
        ]),
        AddNavigationListener () {
            const isIframe = window !== window.parent;
            const isRfpForm = document.location.href.indexOf("/formularz/") > -1;
            if (!(isIframe && isRfpForm)) window.addEventListener("popstate", (event)=>{
                const { StateManager: stateManager } = this;
                if (event.state && stateManager) {
                    if (!Array.isArray(stateManager.InternalStack)) return;
                    const vueRoutes = this.$route.path.startsWith("/konto/profil/uslugi-produkty");
                    if (vueRoutes && this.CurrentState.Section === "Services") return;
                    if (vueRoutes) this.$router.replace({
                        name: "Services"
                    });
                    stateManager.InternalStack.pop();
                    stateManager.Resolve(stateManager.InternalStack[stateManager.InternalStack.length - 1], true);
                }
            });
        },
        ShowTotalChatMsgNotification (value) {
            if (window.localStorage.getItem("isBuyerApp") === "true") {
                const element = document.querySelector('.navbar-counter[data-type="buyerAppTotalMsg"]');
                if (element) element.innerText = value;
            }
        },
        SubmenuTravel (v) {
            this.Submenu.Travel(v, this);
        },
        async Logout () {
            this.IsLoading = true;
            await fetch(this.loggedAs ? "/j_acegi_exit_user" : "/j_acegi_logout");
            document.location.href = "/";
        },
        async Hello () {
            if (document.location.href.indexOf("/formularz/") > -1) {
                // Ustaw kolor na formularzu - najlepiej przed załadowaniem całości.
                const formStyle = document.createElement("style");
                formStyle.innerHTML = "#preload-placeholder { background: #e97407; } #preload-placeholder .lds-ellipsis div { background: #ffffff; } html, body { overflow: hidden !important; }";
                document.head.appendChild(formStyle);
            }
            const Hello = await this.ServerManager.Hello((window.MODULE || (0, $aqSUB.AppModules).MY_OFERTEO) !== (0, $aqSUB.AppModules).MY_OFERTEO || window.location.href.indexOf("/konto/zaplac") !== -1 || window.location.href.indexOf("/konto/polecanie") !== -1);
            this.Analytics.Create();
            const { href: href, pathname: pathname } = window.location;
            let stateManagerUrl = pathname;
            if (Hello.needsLogin) {
                this.Module = "LoginRegister";
                stateManagerUrl = "/logowanie";
                if (!document.location.href.endsWith("/konto")) window.localStorage["LoginRedirectTo"] = document.location.href;
            } else this.Module = window.MODULE || (0, $aqSUB.AppModules).MY_OFERTEO;
            if (href.indexOf("/buyer-app/") > -1) {
                stateManagerUrl = window.location.pathname;
                this.Module = "MobileBuyerAppPanel";
            }
            if (href.indexOf("buyer-app-contest") > -1) {
                if (window.localStorage.getItem("isBuyerApp") === "true") {
                    stateManagerUrl = window.location.pathname;
                    this.Module = "BuyerAppContestPage";
                } else if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|appstore.oferteo/i.test(navigator.userAgent)) window.location.href = "/buyer-app/homepage";
                else window.location.href = "/";
            }
            if (href.includes("rozprowadzarka")) this.Module = "ExpressSpreader";
            if (href.indexOf("wystaw-opinie") > -1) {
                stateManagerUrl = window.location.pathname;
                this.Module = "ReviewFormPage";
            }
            // Jeżeli przechodzimy do Mojego Oferteo, ale nie wyspecyfikujemy na którą konkretnie stronę,
            // przejdź na Zapytania lub Kontakty w zależności od tego, czy mamy jakieś nieprzeczytane wiadomości.
            if ([
                "/konto",
                "/konto/",
                "/konto/zapytania"
            ].includes(stateManagerUrl)) stateManagerUrl = `/konto/${this.appStore.hasFlag("newMessagesSinceLastVisit") ? "kontakty" : "zapytania"}`;
            // Jeżeli jesteśmy na stronie Zapytań bądź Kontaktów, wyświetl Onboarding, o ile jest co pokazać.
            if (this.canShowOnboarding(href)) stateManagerUrl = "/witaj";
            // Utwórz instancję menedżera stanów.
            this.StateManager = new (0, $8d2e7.default)(stateManagerUrl, this.Module);
            this.LoggedUser = Hello.User;
            if (document.location.href.indexOf("/formularz/") <= 0) {
                const appType = await (0, $lJLdg.getAppType)();
                this.Push = new (0, $aaBFb.default)(Hello.User.UserId, false, appType, document.location.href);
            }
            this.mobileAppRoutine(Hello);
            this.sendAnalytics();
            this.IsLoading = false;
            this.DisplaySavingScreen = false;
            if (this.$refs.CurrentModule && this.$refs.CurrentModule.OnHello) this.$refs.CurrentModule.OnHello();
            this.moduleFromStore = this.Module;
            if (Hello.servicesNotificationMessage) {
                const servicesStore = (0, $bzYqW.useServicesStore)();
                servicesStore.setNotifications(Hello.servicesNotificationMessage);
            }
        },
        /**
		 * Procedury wykonywane tylko dla aplikacji mobilnych.
		 */ mobileAppRoutine (hello) {
            const { userAgent: ua } = navigator;
            const isAppleApp = ua.indexOf("appstore.oferteo") > -1;
            const isApplePhone = ua.match(/iPhone/i);
            const isPwa = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
            const { UserId: userId } = hello.User;
            // Analityka PWA
            if (userId && isPwa && this.Module === (0, $aqSUB.AppModules).MY_OFERTEO) (0, $aKWFw.default)("/profile/log-pwa-entry.ofer");
            // Wyłącz pokazywanie się paska z prośbą o instalację PWA.
            window.addEventListener("beforeinstallprompt", (e)=>{
                e.preventDefault();
            });
            // Wyłącz płatności w aplikacji iOS, jeżeli nie jest ustawiona flaga `enable_ios_payments`
            const shouldDisablePayments = this.hasFlag("enableAppStorePayments");
            if (isAppleApp && shouldDisablePayments) this.addFlag("disableAppStorePayments");
            // Zapisz w localStorage, że jesteśmy w aplikacji iOS
            if (isAppleApp) window.localStorage["IsApp"] = true;
            // Zapisz w localStorage, jeśli przyszliśmy z TWA
            if (document.referrer.includes("android-app://")) window.localStorage["IsApp"] = "yes";
            // Wyłącz przybliżenie ekranu po kliknięciu w input.
            if (isAppleApp || isApplePhone) {
                const viewportElement = document.querySelector('meta[name="viewport"]');
                viewportElement === null || viewportElement === void 0 ? void 0 : viewportElement.setAttribute("content", "width=device-width, initial-scale=1, maximum-scale=1");
            }
        },
        /**
		 * Wysyła informację analityczną zaraz po wejściu na stronę.
		 * Zawiera ona informację o typie urządzenia, status pozwolenia na powiadomienia Push oraz token.
		 */ sendAnalytics () {
            window.setTimeout(()=>{
                const { userAgent: userAgent } = navigator;
                const isApp = window.localStorage["IsApp"] === "yes" || userAgent.indexOf("appstore.oferteo") > -1;
                let pushPermission;
                if (isApp) pushPermission = "granted";
                else if (typeof Notification !== "function") pushPermission = "denied";
                else pushPermission = Notification.permission;
                if (navigator.userAgent.indexOf("appstore.oferteo") > -1) pushPermission = window.localStorage.CordovaEnableTracking === "yes" ? "granted" : "denied";
                fetch(`/profile/analytics-set-device-type.ofer?deviceType=${(0, $7eFUb.default)()}&pushPermission=${pushPermission}&token=${window.localStorage["notificationToken"]}`);
            }, 5000);
        },
        EnablePushNotifications (source = "") {
            this.Push.AskAndSubscribePush(this.Push.UserId);
            if (source && typeof Notification === "function" && Notification.permission === "granted") this.Analytics.Gtm(source);
        },
        HideDimmed () {
            document.querySelector(".is-dimmed").style.display = "none";
        },
        DownloadTOSInModal (url, filename) {
            const linkElement = document.createElement("a");
            linkElement.href = url;
            linkElement.download = filename;
            document.body.appendChild(linkElement);
            linkElement.click();
            document.body.removeChild(linkElement);
        }
    }
};

});
parcelRequire.register("8uJrH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62f460a3a3f3aa30$export$2e2bcd8739ae039; });
let $62f460a3a3f3aa30$var$script;




let $62f460a3a3f3aa30$var$initialize = ()=>{
    $62f460a3a3f3aa30$var$script = (parcelRequire("jTIlP"));
    if ($62f460a3a3f3aa30$var$script.__esModule) $62f460a3a3f3aa30$var$script = $62f460a3a3f3aa30$var$script.default;
    $62f460a3a3f3aa30$var$script.render = (parcelRequire("lcQCE")).render;
    $62f460a3a3f3aa30$var$script.__cssModules = {};
    (parcelRequire("3fvxt")).default($62f460a3a3f3aa30$var$script);
    $62f460a3a3f3aa30$var$script.__scopeId = "data-v-59ed87";
    $62f460a3a3f3aa30$var$script.__file = "WebsocketsElement.vue";
};
$62f460a3a3f3aa30$var$initialize();
var $62f460a3a3f3aa30$export$2e2bcd8739ae039 = $62f460a3a3f3aa30$var$script;

});
parcelRequire.register("jTIlP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $53054f7f60d2e16e$export$2e2bcd8739ae039; });

var $jAQww = parcelRequire("jAQww");

var $hDoNm = parcelRequire("hDoNm");

var $3wB1H = parcelRequire("3wB1H");

var $aokJ6 = parcelRequire("aokJ6");

var $2z5fq = parcelRequire("2z5fq");

var $jfoP4 = parcelRequire("jfoP4");

var $4cl59 = parcelRequire("4cl59");

var $eLlJi = parcelRequire("eLlJi");
var // @vuese
// Komponent odpowiedzialny za wyświetlanie powiadomień o nowych zleceniach i wiadomościach z czatu.
// @group Base Components
$53054f7f60d2e16e$export$2e2bcd8739ae039 = {
    name: "WebsocketsElement",
    emits: [
        "ShowTotalChatMsgNotification"
    ],
    computed: {
        ...(0, $hDoNm.mapState)((0, $jfoP4.useAppStore), [
            "sessionId",
            "websocketUrl"
        ]),
        ...(0, $hDoNm.mapStores)((0, $2z5fq.useUserStore))
    },
    data () {
        return {
            Socket: null,
            AudioData: "data:audio/mpeg;base64,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",
            Audio: null,
            LastSocketMessage: {},
            OnlineStatusList: {},
            OnlineStatusElements: []
        };
    },
    watch: {
        sessionId (n) {
            if (n) this.CreateSocket(n);
        }
    },
    mounted () {
        this.CreateSocket();
        this.Audio = new Audio(this.AudioData);
        this.Analytics.Socket = this.Socket;
        window.setInterval(()=>{
            this.OnlineStatusListRefresh();
        }, 15000);
    },
    methods: {
        ...(0, $hDoNm.mapActions)((0, $eLlJi.useBuyerMessagesStore), [
            "ringTheBell"
        ]),
        OnlineStatusListRefresh () {
            const current = [
                ...document.querySelectorAll(".online-status[data-online-status]")
            ].map((el)=>el.getAttribute("data-online-status")).sort();
            const previous = this.OnlineStatusElements;
            if (!current.length) this.OnlineStatusList = {};
            if (current.join("|") !== previous.join("|")) {
                this.OnlineStatusElements = current;
                if (this.Socket) this.Socket.Send({
                    type: "OnlineStatus",
                    data: {
                        ids: current
                    }
                });
            }
        },
        OnOnlineStatusList (m) {
            const list = m.ids;
            this.OnlineStatusList = {
                ...this.OnlineStatusList,
                ...list
            };
        },
        CreateSocket () {
            if (!this.websocketUrl) return;
            this.Socket = new (0, $3wB1H.default)(this, this.sessionId, this.websocketUrl);
        },
        async OnSocketMessage (m) {
            // Ignoruj, jeżeli wiadomość jest duplikatem ~ bug związany z rozłączaniem się serwera przy np. restartach.
            const stringified = JSON.stringify(m.data);
            const excludeDuplicate = [
                "ChatMessageRead",
                "ChatMessageTyping",
                "NotificationCounters"
            ];
            if (m.data && this.LastSocketMessage[m.type] === stringified && !excludeDuplicate.includes(m.type)) return;
            this.LastSocketMessage[m.type] = stringified;
            switch(m.type){
                case "Hello":
                    this.Socket.Send({
                        type: "NotificationCounters"
                    });
                    break;
                case "NotificationCounters":
                    this.OnNotificationCounters(m.data);
                    break;
                case "Notification":
                    this.OnNotification(m.data);
                    break;
                case "ChatMessage":
                    (0, (/*@__PURE__*/$parcel$interopDefault($jAQww))).emit("notification-chat-message", m.data);
                    break;
                case "Balance":
                    this.OnBalance(m.data);
                    break;
                case "OnlineStatus":
                    this.OnOnlineStatusList(m.data);
                    break;
                case "ChatMessageRead":
                    (0, (/*@__PURE__*/$parcel$interopDefault($jAQww))).emit("notification-chat-read", m.data);
                    break;
                case "ChatMessageTyping":
                    (0, (/*@__PURE__*/$parcel$interopDefault($jAQww))).emit("notification-chat-typing", m.data);
                    break;
                case "UncoverNotification":
                    (0, (/*@__PURE__*/$parcel$interopDefault($jAQww))).emit("notification-chat-read", m.data);
                    break;
                case "Logout":
                    await fetch("/j_acegi_logout");
                    document.location.href = "/logowanie";
                    break;
                default:
                    break;
            }
        },
        OnBalance (b) {
            const userStore = (0, $2z5fq.useUserStore)();
            userStore.paymentProgress = userStore.accountBalance < b.accountBalance ? "success" : "fail";
            userStore.accountBalance = b.accountBalance;
        },
        // WebsocketNotifications.OnNotificationCounters({ rfps: 12, chats: [ 'XXX:XXX' ] })
        OnNotificationCounters (c) {
            if (!c) return;
            if (c.idChats) c.chats = c.idChats;
            const notificationCounters = (0, $aokJ6.useNotificationCountersStore)();
            if (c.totalUnreadChatMessages && window.localStorage.getItem("isBuyerApp") === "true") this.$emit("ShowTotalChatMsgNotification", c.totalUnreadChatMessages);
            if (c.chats !== undefined) {
                notificationCounters.newChatsList = c.chats;
                notificationCounters.newContacts = c.chats.length;
                notificationCounters.totalUnreadNotifications += 1;
            }
            if (c.rfps !== undefined) notificationCounters.newRfps = c.rfps;
            notificationCounters.newRfps = c.rfps || 0;
            notificationCounters.newContacts = c.totalUnreadChatMessages || 0;
            notificationCounters.totalUnreadNotifications = notificationCounters.newRfps + notificationCounters.newContacts;
            this.ChangeWindowTitle(notificationCounters.totalUnreadNotifications);
        },
        // WebsocketNotifications.ChangeWindowCounter(12)
        ChangeWindowTitle (n) {
            try {
                let t = document.title;
                const match = t.matchAll(/\((\d+)\) (.+)/g).next().value;
                if (match && match.length === 3) t = match.at(2);
                document.title = (n > 0 ? `(${n}) ` : "") + t;
            } catch (err) {
                return false;
            }
            return true;
        },
        OnNotification (n) {
            if (this.CurrentModule === "BuyerView" || this.CurrentModule === "MobileBuyerAppPanel") this.ringTheBell();
            if (n.idChat) {
                this.OnChatNotification(n);
                return;
            }
            if (!n || !n.notificationType) return;
            const type = n.notificationType.toLowerCase();
            (0, (/*@__PURE__*/$parcel$interopDefault($jAQww))).emit(`notification-${type}`, n);
            switch(type){
                case "rfp":
                    this.OnRfpNotification(n);
                    break;
                case "chat":
                    this.OnChatNotification(n);
                    break;
                default:
                    break;
            }
        },
        OnRfpNotification (n) {
            const notificationCounters = (0, $aokJ6.useNotificationCountersStore)();
            n.idGroup = n.idRfp;
            // Nie wyświetlaj powiadomienia na tym samym RFP
            if (!this.PreventNotificationDisplay(n)) this.DisplayNotification(n);
            if ([
                "uncCustSK",
                "uncBuyerAP"
            ].indexOf(n.uncoverType) > -1) this.OnNotificationCounters({
                chats: [
                    ...notificationCounters.newChatsList,
                    n.idGroup
                ],
                rfps: notificationCounters.newRfps
            });
            else this.OnNotificationCounters({
                chats: notificationCounters.newChatsList,
                rfps: notificationCounters.newRfps + 1
            });
        },
        OnChatNotification (n) {
            const notificationCounters = (0, $aokJ6.useNotificationCountersStore)();
            n.idGroup = n.idChat;
            if (!this.PreventNotificationDisplay(n)) {
                this.DisplayNotification(n);
                if (this.CurrentModule === "CustomerView" && notificationCounters.newChatsList.indexOf(n.idGroup) === -1) this.OnNotificationCounters({
                    chats: [
                        ...notificationCounters.newChatsList,
                        n.idGroup
                    ],
                    rfps: notificationCounters.newRfps
                });
                else {
                    this.OnNotificationCounters({
                        chats: [
                            ...notificationCounters.newChatsList,
                            n.idGroup
                        ],
                        rfps: notificationCounters.newRfps
                    });
                    if (this.CurrentState.RfpId) this.UpdateBuyerCustomerChatCounters(n);
                    this.UpdateBuyerRfpChatCounters(n);
                }
            }
        },
        PreventNotificationDisplay (n) {
            const rfpId = Number(this.CurrentState.RfpId);
            if (this.CurrentModule === "CustomerView") return rfpId === n.idGroup || rfpId === n.idRfp;
            return (rfpId === n.idGroup || rfpId === n.idRfp) && this.CurrentState.CustomerId === n.idCustomer;
        },
        OnNotificationAnimationEnd (e) {
            const $t = e.target;
            switch(e.animationName){
                case "sn-notification-enter":
                    $t.className = "is-staying";
                    break;
                case "sn-notification-stay":
                    $t.className = "is-leaving";
                    break;
                case "sn-notification-leave":
                    $t.remove();
                    break;
                default:
                    break;
            }
        },
        OnNotificationClick (e) {
            const $t = e.target;
            if ($t.matches(".sn-notification-close")) {
                e.preventDefault();
                $t.closest("a").className = "is-leaving";
            }
        },
        PlayAudio () {
            try {
                const audio = new Audio();
                audio.autoplay = true;
                audio.src = this.AudioData;
            } catch (err) {}
            window.AudioIsPlaying = true;
            window.setTimeout(()=>{
                window.AudioIsPlaying = false;
            }, 1000);
        },
        UpdateBuyerCustomerChatCounters (n) {
            try {
                const $c = document.querySelector(`.rfp-customer-card[data-customer-id="${n.idCustomer}"]`);
                if (!$c) return;
                const counterEl = $c.querySelector(".customer-chats-counter span");
                if (!counterEl) {
                    const $el = document.createElement("span");
                    $el.innerHTML = "1";
                    $c.querySelector(".customer-chats-counter").appendChild($el);
                    return;
                }
                counterEl.innerHTML = (Number(counterEl.innerHTML) + 1).toString();
            } catch (err) {
                console.log(err);
            }
        },
        UpdateBuyerRfpChatCounters (n) {
            try {
                const $r = document.querySelector(`.buyer-rfp-list-item[data-rfp-id="${n.idRfp}"]`);
                if (!$r) return;
                const counterEl = $r.querySelector(".rfp-chats-counter span");
                counterEl.innerHTML = (Number(counterEl.innerHTML) + 1).toString();
            } catch (err) {
                console.log(err);
            }
        },
        // WebsocketNotifications.DisplayNotification({ title: `Test`, message: 'Test' });
        DisplayNotification (n) {
            const $c = this.$refs.SocketsContainer;
            if (!n || !$c || !n.title) return;
            n.url = n.url || "";
            let sound = false;
            if (this.Audio && this.userStore.isCustomer && !(window.AudioIsPlaying || window.localStorage.DisableAudio === "true")) {
                this.PlayAudio();
                sound = true;
            }
            // Nie pokazuj powiadomienia, jeżeli dotyczy aktualnie wyświetlanego rfp lub jeżeli istnieje this.CurrentState.CustomerId, to obecnie wyświetlanego chatu
            if (this.CurrentState.RfpId && n.url.indexOf(this.CurrentState.RfpId) > -1 && this.CurrentState.CustomerId === n.idCustomer) return;
            const $n = document.createElement("a");
            const separator = n.url.indexOf("?") > -1 ? "&" : "?";
            const deviceData = `deviceData=${window.matchMedia("(pointer: fine)").matches ? "desktop" : "mobile"}`;
            $n.href = (n.url || "") + separator + deviceData;
            $n.setAttribute("data-group-id", n.idGroup);
            if (n.image) {
                $n.setAttribute("data-style", "rfp-with-image");
                let s = n.onlineStatus;
                s = s > 0 ? this.Format.TimeAgo(s) : s;
                let sex = n.customerPersonSex;
                sex = !sex ? "" : `data-sex="${sex === "F" ? "K" : "M"}"`;
                n.image = `/images/hero/${n.image}-zlecenia-oferty-h.jpg`;
                $n.innerHTML = `
				<div class="sn-notification-image" style="background-image: url(${n.image})"></div>
				<div class="sn-notification-message-container">
					<div class="sn-notification-title">${n.title + (n.unreadMessages ? ` (${n.unreadMessages})` : "")}</div>
					<div class="sn-badges">
						<div class="sn-badge is-badge-person">${n.contactPersonName || ""}</div>
						<div class="sn-badge is-badge-location">${n.location || ""}</div>
						<div class="sn-badge is-badge-online-status" style="display:none!important">
							<div class="online-status" ${sex} data-status="${s}"></div>
						</div>
					</div>
					<div>${n.message || ""}</div>
				</div>
				<div class="sn-notification-close"></div>
			`;
            } else $n.innerHTML = `
				<div class="sn-notification-title">${n.title + (n.unreadMessages ? ` (${n.unreadMessages})` : "")}</div>
				<div class="sn-notification-message">${n.message}</div>
				<div class="sn-notification-close"></div>
			`;
            let eventLabel = "other";
            if (n.notificationType === "RFP") switch(n.uncoverType){
                case "rfpNotify":
                    eventLabel = "rfp";
                    break;
                case "uncCustSK":
                case "uncBuyerSK":
                    eventLabel = "quick";
                    break;
                case "uncCustAP":
                case "uncBuyerAP":
                    eventLabel = "automatic";
                    break;
                case "uncBuyerPF":
                case "uncBuyerPFNew":
                    eventLabel = "recommendation";
                    break;
                default:
                    break;
            }
            else eventLabel = "chat";
            let eventLabelLegacy = "inne";
            if (n.notificationType === "RFP") switch(n.uncoverType){
                case "rfpNotify":
                    eventLabelLegacy = "rfp";
                    break;
                case "uncCustSK":
                case "uncBuyerSK":
                    eventLabelLegacy = "sk";
                    break;
                case "uncCustAP":
                case "uncBuyerAP":
                    eventLabelLegacy = "ap";
                    break;
                case "uncBuyerPF":
                case "uncBuyerPFNew":
                    eventLabelLegacy = "pf";
                    break;
                default:
                    break;
            }
            else eventLabelLegacy = "czat";
            eventLabelLegacy += ` - ${sound ? "sound_on" : "sound_off"} - ${n.idRfp}`;
            (0, $4cl59.addHandler)($n, "click", (e)=>{
                if (e.target.classList.contains("sn-notification-close")) {
                    e.preventDefault();
                    $n.className = "is-leaving";
                    return;
                }
                this.Analytics.Gtm(`websocket_click_${eventLabel}`, {
                    is_sound_enabled: sound,
                    id_rfp: n.idRfp
                });
                const rfp = /\/(\d+)_/.exec($n.href) || "";
                if (rfp) {
                    e.preventDefault();
                    document.location.href = $n.href; // Powoduje przeładowanie całej strony, ale działa na publicznym podglądzie zapytania.
                    $n.className = "is-leaving";
                }
            });
            $n.style.bottom = "32px";
            $c.appendChild($n);
            this.Analytics.Gtm(`websocket_show_${eventLabel}`, {
                is_sound_enabled: sound,
                id_rfp: n.idRfp
            });
        }
    }
};

});
parcelRequire.register("jAQww", function(module, exports) {

var $7blGv = parcelRequire("7blGv");
module.exports = new $7blGv();

});
parcelRequire.register("7blGv", function(module, exports) {
function $53aa6195cda8c8d5$var$E() {
// Keep this empty so it's easier to inherit from
// (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}
$53aa6195cda8c8d5$var$E.prototype = {
    on: function(name, callback, ctx) {
        var e = this.e || (this.e = {});
        (e[name] || (e[name] = [])).push({
            fn: callback,
            ctx: ctx
        });
        return this;
    },
    once: function(name, callback, ctx) {
        var self = this;
        function listener() {
            self.off(name, listener);
            callback.apply(ctx, arguments);
        }
        listener._ = callback;
        return this.on(name, listener, ctx);
    },
    emit: function(name) {
        var data = [].slice.call(arguments, 1);
        var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
        var i = 0;
        var len = evtArr.length;
        for(i; i < len; i++)evtArr[i].fn.apply(evtArr[i].ctx, data);
        return this;
    },
    off: function(name, callback) {
        var e = this.e || (this.e = {});
        var evts = e[name];
        var liveEvents = [];
        if (evts && callback) {
            for(var i = 0, len = evts.length; i < len; i++)if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
        }
        // Remove event from queue to prevent memory leak
        // Suggested by https://github.com/lazd
        // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
        liveEvents.length ? e[name] = liveEvents : delete e[name];
        return this;
    }
};
module.exports = $53aa6195cda8c8d5$var$E;
module.exports.TinyEmitter = $53aa6195cda8c8d5$var$E;

});


parcelRequire.register("3wB1H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1488c3b31e821a3$export$2e2bcd8739ae039; });
class $b1488c3b31e821a3$export$2e2bcd8739ae039 {
    CreateSocket() {
        if (this.ConnectionAttemps > 30) {
            this.OnError("CreateSocket: Hit limit.");
            return;
        }
        try {
            this.ConnectionAttemps++;
            let connectUrl = `${this.BaseUrl}?sessionId=${this.SessionId}`;
            if (this.ReconnectToken) connectUrl += `&token=${this.ReconnectToken}`;
            this.Socket = new WebSocket(connectUrl);
            this.Socket.addEventListener("open", (e)=>this.OnOpen(e));
            this.Socket.addEventListener("message", (e)=>this.OnMessage(e));
            this.Socket.addEventListener("close", (e)=>this.OnClose(e));
            this.Socket.addEventListener("error", ()=>this.OnError(""));
            window.setInterval(()=>{
                this.Send({
                    type: "Heartbeat"
                });
            }, 60000);
        } catch (err) {
            this.OnError(err);
        }
    }
    OnOpen() {
        this.Socket.send(JSON.stringify({
            type: "Hello",
            data: {
                sessionId: this.SessionId
            }
        }));
    }
    OnError() {}
    OnMessage(e) {
        if (!e.data || this.ConnectionAttemps > 30) {
            this.OnError("OnMessage: No data or hit limit.");
            return;
        }
        const m = JSON.parse(e.data);
        if (m.type === "Hello") this.Init(m);
        this.Consumers.forEach((c)=>c.OnSocketMessage(m));
    }
    OnClose() {
        this.Connected = false;
        window.setTimeout(()=>{
            this.CreateSocket();
        }, 30000);
    }
    Init(m) {
        this.Connected = m.data.status === "SUCCESS";
        if (m.data.token && (!this.ReconnectToken || m.data.token !== this.ReconnectToken)) this.ReconnectToken = m.data.token;
        if (this.Connected) {
            for (const queuedMessage of this.Queue)this.Send(queuedMessage);
            this.Queue = [];
        }
    }
    Send(m) {
        if (this.ConnectionAttemps > 30) {
            this.OnError("Send: Hit limit.");
            return;
        }
        if (this.Connected) this.Socket.send(JSON.stringify(m));
        else this.Queue.push(m);
    }
    constructor(consumer, sessionId, baseUrl){
        this.Consumers = [];
        this.Queue = [];
        this.ConnectionAttemps = 0;
        this.SessionId = sessionId;
        const www = document.location.hostname;
        if (!baseUrl) {
            const protocol = document.location.protocol === "http:" ? "ws://" : "wss://";
            baseUrl = `${protocol + www}/wss`;
            // baseUrl = 'ws://wss.oferteo-dev.pl';
            if (www.indexOf("oferteo-fix.pl") > -1) baseUrl = "wss://wss.oferteo-fix.pl";
            if (www.indexOf("oferteo-tst.pl") > -1) baseUrl = "wss://wss.oferteo-tst.pl";
            if (www.indexOf("oferteo-pre.pl") > -1) baseUrl = "wss://wss.oferteo-pre.pl";
            if (www.indexOf("oferteo.pl") > -1) baseUrl = "wss://wss.oferteo.pl";
        }
        this.BaseUrl = baseUrl;
        if (consumer && "OnSocketMessage" in consumer) {
            this.Consumers.push(consumer);
            this.CreateSocket();
        } else this.OnError("No consumer specified.");
    }
}

});

parcelRequire.register("aokJ6", function(module, exports) {

$parcel$export(module.exports, "useNotificationCountersStore", function () { return $92616361621f54e1$export$c85f671e68751326; });

var $hDoNm = parcelRequire("hDoNm");
const $92616361621f54e1$export$c85f671e68751326 = (0, $hDoNm.defineStore)({
    id: "notificationCounters",
    state: ()=>({
            newRfps: 0,
            newContacts: 0,
            newChats: 0,
            newChatsList: [],
            totalUnreadNotifications: 0,
            totalUnread: 0
        }),
    actions: {}
});

});


parcelRequire.register("lcQCE", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $f70389a7ddd292f9$export$b3890eb0ae9dca99; });

var $iIzY2 = parcelRequire("iIzY2");
const $f70389a7ddd292f9$var$_hoisted_1 = {
    "data-component": "WebsocketsElement.vue"
};
function $f70389a7ddd292f9$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $iIzY2.openBlock)(), (0, $iIzY2.createElementBlock)("div", $f70389a7ddd292f9$var$_hoisted_1, [
        (0, $iIzY2.createElementVNode)("div", {
            ref: "SocketsContainer",
            class: "[ sn-container ]",
            onAnimationend: _cache[0] || (_cache[0] = (...args)=>$options.OnNotificationAnimationEnd && $options.OnNotificationAnimationEnd(...args)),
            onClick: _cache[1] || (_cache[1] = (...args)=>$options.OnNotificationClick && $options.OnNotificationClick(...args))
        }, null, 544)
    ]);
}

});

parcelRequire.register("3fvxt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25db3cc1d3102cc5$export$2e2bcd8739ae039; });
let $25db3cc1d3102cc5$var$NOOP = ()=>{};
var $25db3cc1d3102cc5$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("2GVJN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f5c4a88a539d233$export$2e2bcd8739ae039; });
let $1f5c4a88a539d233$var$script;



let $1f5c4a88a539d233$var$initialize = ()=>{
    $1f5c4a88a539d233$var$script = (parcelRequire("76u12"));
    if ($1f5c4a88a539d233$var$script.__esModule) $1f5c4a88a539d233$var$script = $1f5c4a88a539d233$var$script.default;
    $1f5c4a88a539d233$var$script.render = (parcelRequire("h1oSQ")).render;
    (parcelRequire("6rVPL")).default($1f5c4a88a539d233$var$script);
    $1f5c4a88a539d233$var$script.__scopeId = "data-v-628cf4";
    $1f5c4a88a539d233$var$script.__file = "PwaDialog.vue";
};
$1f5c4a88a539d233$var$initialize();
var $1f5c4a88a539d233$export$2e2bcd8739ae039 = $1f5c4a88a539d233$var$script;

});
parcelRequire.register("76u12", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $fb86aae4246f0c9a$export$2e2bcd8739ae039; });

var $cDSiu = parcelRequire("cDSiu");
var // @vuese
// Komponent odpowiedzialny za wyświetlenie pytania o instalację PWA.
// @group Base Components
$fb86aae4246f0c9a$export$2e2bcd8739ae039 = {
    name: "PwaDialog",
    data () {
        return {
            DefferedPrompt: null,
            Shown: false,
            AnalyticsLabel: "",
            TimesClicked: 0,
            IsSafari: false
        };
    },
    mounted () {
        window.addEventListener("beforeinstallprompt", (e)=>{
            e.preventDefault();
            window["DefferedPrompt"] = e;
            this.DefferedPrompt = e;
            this.Show();
        });
        this.Show();
    },
    methods: {
        Show () {
            var k, v;
            return;
        },
        Confirm () {
            this.TimesClicked++;
            if (this.TimesClicked > 2) {
                this.Shown = false;
                return;
            }
            try {
                $cDSiu.goToStore();
                this.Shown = false;
            } catch (err) {
                console.error(err);
            }
        },
        Cancel (source) {
            source = source === "button" ? "kontynuuj w przeglądarce" : "klik poza obszar";
            this.Shown = false;
        }
    }
};

});

parcelRequire.register("h1oSQ", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $c645d5059a2c1ea0$export$b3890eb0ae9dca99; });

var $iIzY2 = parcelRequire("iIzY2");
const $c645d5059a2c1ea0$var$_hoisted_1 = {
    class: "flex items-center mb-5"
};
const $c645d5059a2c1ea0$var$_hoisted_2 = /*#__PURE__*/ (0, $iIzY2.createElementVNode)("div", {
    class: "heading-small",
    style: {
        "font-size": "18px"
    }
}, " Docieraj do Klient\xf3w szybciej z\xa0aplikacją\xa0mobilną! ", -1);
function $c645d5059a2c1ea0$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BaseIcon = (0, $iIzY2.resolveComponent)("BaseIcon");
    const _component_ModalDialog = (0, $iIzY2.resolveComponent)("ModalDialog");
    return (0, $iIzY2.openBlock)(), (0, $iIzY2.createElementBlock)("div", {
        "data-component": "PwaDialog.vue",
        class: "pwa-prompt",
        onClick: _cache[4] || (_cache[4] = ($event)=>$options.Cancel("backdrop"))
    }, [
        (0, $iIzY2.createVNode)(_component_ModalDialog, {
            class: "is-dialog is-from-bottom",
            Visible: $data.Shown
        }, {
            default: (0, $iIzY2.withCtx)(()=>[
                    (0, $iIzY2.createElementVNode)("div", {
                        class: "p-5",
                        onClick: _cache[2] || (_cache[2] = (0, $iIzY2.withModifiers)(()=>{}, [
                            "stop"
                        ])),
                        onWheel: _cache[3] || (_cache[3] = (0, $iIzY2.withModifiers)(()=>{}, [
                            "prevent"
                        ]))
                    }, [
                        (0, $iIzY2.createElementVNode)("div", $c645d5059a2c1ea0$var$_hoisted_1, [
                            (0, $iIzY2.createVNode)(_component_BaseIcon, {
                                class: "flex-none mr-3",
                                size: "2.5",
                                set: "twotone",
                                name: "smartphone"
                            }),
                            $c645d5059a2c1ea0$var$_hoisted_2
                        ]),
                        (0, $iIzY2.createElementVNode)("button", {
                            class: "btn btn-primary w-full mb-3",
                            onClick: _cache[0] || (_cache[0] = (...args)=>$options.Confirm && $options.Confirm(...args))
                        }, (0, $iIzY2.toDisplayString)($data.IsSafari ? "Pobierz w App Store" : "Pobierz w sklepie Play"), 1),
                        (0, $iIzY2.createElementVNode)("button", {
                            class: "btn w-full",
                            onClick: _cache[1] || (_cache[1] = (0, $iIzY2.withModifiers)(($event)=>$options.Cancel("button"), [
                                "prevent"
                            ]))
                        }, " Kontynuuj w przeglądarce ")
                    ], 32)
                ]),
            _: 1
        }, 8, [
            "Visible"
        ])
    ]);
}

});

parcelRequire.register("6rVPL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b222049b7178bda$export$2e2bcd8739ae039; });
let $4b222049b7178bda$var$NOOP = ()=>{};
var $4b222049b7178bda$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("8d2e7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b888b8f6ef6eab6$export$2e2bcd8739ae039; });

var $2z5fq = parcelRequire("2z5fq");

var $4FjZA = parcelRequire("4FjZA");
class $5b888b8f6ef6eab6$export$2e2bcd8739ae039 {
    Resolve(url, fromHistory) {
        let component = url;
        let state = {};
        try {
            if (url.indexOf("|") > -1) {
                const data = component.split("|");
                component = data[0];
                state = JSON.parse(data[1]);
            }
        } catch (err) {
            let entry = document.location.href.replace(document.location.origin, "");
            entry = this.FromUrl(entry);
            component = entry.component;
            state = entry.state;
        }
        this.Travel(component, state, fromHistory ? "history" : true);
    }
    FromUrl(url) {
        const isWithinBase = url.indexOf(this.BaseUrl) > -1;
        const qs = new URLSearchParams(document.location.search);
        url = url.replace(this.BaseUrl, "").toLowerCase() || "/";
        url = url.split("?")[0];
        url = url.startsWith("/") ? url.substr(1) : url;
        url = url.split("/");
        // ZRÓB: Oprzyj to na patternach.
        let component;
        let state = {};
        switch(url[0]){
            case "zaplac":
                component = "InvoicePaymentPage";
                break;
            case "witaj":
                component = "OnboardingPage";
                break;
            case "kontakty":
                component = "Contacts";
                break;
            case "profil":
                component = "CustomerProfileView";
                break;
            case "ustawienia":
                component = "CustomerSettingsView";
                break;
            case "powiadomienia":
                component = "PromoMessagesPage";
                break;
            case "rejestracja":
                component = "LoginRegister";
                state = {
                    LoginPage: "register"
                };
                break;
            case "rejestracja-dostawcy.html":
                component = "LoginRegister";
                state = {
                    LoginPage: "register"
                };
                break;
            case "logowanie":
                component = "LoginRegister";
                state = {
                    LoginPage: "login"
                };
                break;
            case "moje-zapytania":
                component = "BuyerView";
                break;
            case "pomoc":
                component = "QuickPaymentsPage";
                break;
            case "polecanie":
                component = "RecommendationPage";
                break;
            case "promowanie":
                component = "PromotionPage";
                break;
            case "debug":
                component = "Debug";
                break;
            case "wystaw-opinie":
                component = "ReviewFormPage";
                break;
            default:
                component = "Rfps";
        }
        if (url[0] === "buyer-app") {
            // edit przy rozbudowaniu tego urla
            if (url[1] === "auth") component = "BuyerAppAuth";
            if (url[1] === "mobile-auth") component = "BuyerAppAuth";
            if (url[1] === "rfp-list") {
                component = "BuyerList";
                if (url[2] === "rfp") {
                    component = "BuyerRfpDetails";
                    state.RfpId = url[3];
                }
                if (url[5] === "czat") {
                    component = "RfpChatCustomerInfo";
                    state.RfpId = url[3];
                    state.CustomerId = url[4];
                    state.Section = "rfp-chat";
                }
            }
            if (url[1] === "homepage") component = "MobileBuyerAppHomepage";
        }
        if (url[0] === "terminarz") {
            component = "SchedulerPage";
            if (url[1]) state.TermId = url[1];
        }
        if (url[0] === "zaplac") state = {
            InvoiceId: qs.get("paymentToken"),
            IsAutomatic: qs.get("automaticPayments")
        };
        if ((url[0] === "zobacz" || url[0] === "rfp") && !isWithinBase) {
            component = "PublicView";
            state = {
                Public: false,
                RfpId: url[1] ? url[1].split("_")[0] : "",
                AutoUncover: url[2] === "odkryj" || this.EntryQueryUrl.indexOf("doUncover") > -1
            };
        }
        if (url[0] === "moje-zapytania") {
            if (!url[1]) component = "BuyerList";
            else if (url[1] === "profil") {
                component = "BuyerProfile";
                if (url[2] === "ustaw-haslo") state.Section = "change-password";
                if (url[2] === "powiadomienia") state.Section = "notifications-settings";
            } else if (url[1] === "order") {
                component = "BuyerExpressOrderDetails";
                state.id = url[2];
            } else if (url[2]) {
                component = "BuyerRfpDetails";
                state.RfpId = Number(url[2]);
                if (url[3]) {
                    component = "RfpChatCustomerInfo";
                    state.CustomerId = Number(url[3]);
                    state.Section = url[4] === "informacje" ? "rfp-customer-info" : "rfp-chat";
                }
            }
        }
        if (url[0] === "formularz") {
            component = "Form";
            let params = url.length > 1 ? url.join("/").replace("formularz/", "") : "";
            params = document.location.search.substr(1);
            state = {
                InitialParams: params
            };
        }
        if (url[0] === "zapytania" || url[0] === "kontakty") {
            state = {
                List: url[0] === "zapytania" ? "Rfps" : "Contacts"
            };
            if (url[1] && url[1].startsWith("filtruj")) state.FilterQuery = url[2];
        }
        if (url[0] === "zapytanie") {
            state = {
                List: "Rfps"
            };
            if (url[2] === "odkryj") state.AutoUncover = true;
            if (url[1] === "czat") {
                state.RfpId = url[2];
                state.ChatMode = true;
            } else state.RfpId = url[1].split("_").shift();
        }
        if (url[0] === "profil" && url[1]) {
            const n = this.ProfileSections.External.indexOf(url[1]);
            state.Section = this.ProfileSections.Internal[n];
            if (url[1] === "oferty" && url[2]) {
                if (url[2] === "nowa") url[2] = -1;
                state.SelectedId = url[2];
            }
            if (url[1] === "opinie" && url[2] === "wyslij") state.AskForReviewsOnLoad = true;
            if (url[1] === "certyfikaty" && url[2]) {
                switch(url[2]){
                    case "sprawdzona-firma":
                        state.SelectedSectionId = "verified";
                        break;
                    case "polecaja-nas":
                        state.SelectedSectionId = "recommended";
                        break;
                    case "profesjonalny-sprzedawca":
                        state.SelectedSectionId = "professional";
                        break;
                    case "ekspert-oferteo":
                        state.SelectedSectionId = "expert";
                        break;
                    case "promuj-firme":
                        state.SelectedSectionId = "widgets";
                        break;
                    case "najlepsi":
                        state.SelectedSectionId = "badges";
                        break;
                    case "odznaki":
                        state.SelectedSectionId = "badges";
                        break;
                    case "naklejki":
                        state.ShowCertificatesBadgesSticker = true;
                        state.SelectedSectionId = "badges";
                        break;
                    default:
                        break;
                }
                if (url[2] === "odznaki" && url[3] && url[3] === "modal") state.AutoDisplay = true;
            }
            if (url[1] === "uslugi-produkty" || url[1] === "uslugi-dodatkowe") state.DisplayAdditionalFilters = url[1] === "uslugi-dodatkowe";
        }
        if (url[0] === "ustawienia" && url[1]) {
            const n = this.SettingsSections.External.indexOf(url[1]);
            state.Section = this.SettingsSections.Internal[n];
            if (url[1] === "historia-operacji") {
                state.Section = "Payments";
                state.HistoryPageType = "History";
            }
            if (url[1] === "faktury") {
                state.Section = "Payments";
                state.HistoryPageType = "Invoices";
            }
            if (url[1] === "admin") state.CustomerId = url[2];
        }
        if (url[0] === "buyer-app-profile" || url[1] === "buyer-app-profile") {
            component = "BuyerAppProfile";
            state.BuyerApp = "Profile";
        }
        if (url[0] === "buyer-app-contest" || url[1] === "buyer-app-contest") {
            component = "BuyerAppContestPage";
            state.BuyerApp = "Contest";
        }
        if (url[0] === "logowanie") {
            component = "LoginRegister";
            if (url[2] && url[2].indexOf("ack=") > -1) {
                component = "BuyerAppAuth";
                state = {
                    LoginPage: "buyer-app-auth",
                    BuyerAppAuth: "buyer-app-mail-complete"
                };
                return {
                    url: url,
                    component: component,
                    state: state
                };
            }
            state = {
                LoginPage: url[1] === "buyer-app-auth" ? "buyer-app-auth" : "login"
            };
            if (window.localStorage.getItem("isBuyerApp") === "true") // dla przekierowań typu przypomnij hasło
            state = {
                LoginPage: "buyer-app-auth"
            };
        }
        if (url[0] === "wystaw-opinie") {
            if (url[1] === "aktywuj") {
                state.isPreview = true;
                state.ReviewId = Number(url[2]);
                if (url[3]) state.Ack = url[3];
            } else {
                component = "ReviewFormPage";
                state.PageComponent = "ReviewFormPage";
                state.CustomerId = Number(url[1]);
                state.SourceId = url[2];
                if (url[3]) state.RfpId = Number(url[3]);
            }
        }
        return {
            url: url,
            component: component,
            state: state
        };
    }
    ToUrl(component, state) {
        const r = [
            this.BaseUrl
        ];
        let title = "";
        component = component || this.CurrentStateName;
        if (component === "Rfps" || component === "Contacts") {
            if (state.RfpId) {
                r.push("zapytanie");
                r.push(`${state.RfpId}_`);
                if (state.QueryParams) r.push(`?${new URLSearchParams(state.QueryParams).toString()}`);
                title = "Zapytanie ofertowe";
            } else {
                r.push((state.List || component) === "Rfps" ? "zapytania" : "kontakty");
                if (state.FilterQuery) {
                    r.push("filtruj");
                    r.push(state.FilterQuery);
                }
                title = (state.List || component) === "Rfps" ? "Zapytania" : "Kontakty";
            }
        }
        if (component === "CustomerProfileView" || component === "CustomerSettingsView" || component === "Settings" || component === "Profile") {
            if (component === "CustomerProfileView") component = "Profile";
            if (component === "CustomerSettingsView") component = "Settings";
            r.push(component === "Profile" ? "profil" : "ustawienia");
            title = component === "Profile" ? "Profil" : "Ustawienia";
            if (state.Section === "Payments" && state.HistoryPageType) r.push(state.HistoryPageType === "History" ? "historia-operacji" : "faktury");
            else if (state.Section) {
                const sl = this[`${component}Sections`];
                const n = sl.Internal.indexOf(state.Section);
                r.push(sl.External[n]);
                // 3SsDRac4bRrP3XqTuSPfHuiXn2yzjghe
                if (sl.Label[n]) title = `${title} › ${sl.Label[n]}`;
                if (state.Section === "Certificates" && state.SelectedSectionId && state.ShowCertificatesBadgesSticker) r.push("naklejki");
                else if (state.Section === "Certificates" && state.SelectedSectionId) {
                    const z = {
                        verified: "sprawdzona-firma",
                        recommended: "polecaja-nas",
                        professional: "profesjonalny-sprzedawca",
                        expert: "ekspert-oferteo",
                        widgets: "promuj-firme",
                        badges: "odznaki"
                    };
                    r.push(z[state.SelectedSectionId] || "szczegoly");
                    if (state.AutoDisplay) r.push("modal");
                    if (state.SelectedSectionId === "badges") title = "Ranking Najlepszych";
                }
            }
            if (state.Section === "ExpressManageCustomers") r.push(state.CustomerId);
            if (state.Section === "Promotion") title = "Profil > Promowanie";
        }
        if (component === "SchedulerPage") {
            title = "Terminarz";
            r.push("terminarz");
            if (state === null || state === void 0 ? void 0 : state.SelectedEvent) r.push(state.SelectedEvent);
        }
        let url = r.join("/");
        if (component === "QuickPaymentsPage") {
            title = "Jak działa Szybkie Doładowanie?";
            url = "/konto/pomoc/szybkie-doladowanie";
        }
        if (component === "RecommendationPage") {
            title = "Jak działa Polecanie?";
            url = "/konto/polecanie";
        }
        if (component === "OnboardingPage") title = "Witamy w Oferteo";
        if (component === "PromoMessagesPage") title = "Powiadomienia";
        if (component === "BuyerMessagesPage") {
            title = "Powiadomienia";
            url = state.Url;
        }
        if (component === "LoginRegister" && (!state.LoginPage || state.LoginPage === "register")) {
            title = "Rejestracja";
            url = `/rejestracja/wybierz-klientow${this.EntryQueryUrl || ""}`;
        }
        if (component === "LoginRegister" && state.LoginPage === "login") {
            title = "Logowanie";
            url = "/logowanie";
        }
        if (component === "LoginRegister" && state.LoginPage === "buyer-app-auth") {
            title = "Logowanie";
            url = "/buyer-app/auth";
        }
        if (component === "PublicView") {
            title = "Zapytanie ofertowe";
            url = `/rfp/${state.RfpId}_`;
        }
        if (component === "BuyerList") {
            if (window.localStorage.getItem("isBuyerApp") === "true") url = "/buyer-app/rfp-list";
            else url = "/konto/moje-zapytania";
            title = "Moje zapytania";
        }
        if (component === "BuyerRfpDetails") {
            if (window.localStorage.getItem("isBuyerApp") === "true") url = `/buyer-app/rfp-list/rfp/${state.RfpId}`;
            else url = `/konto/moje-zapytania/rfp/${state.RfpId}`;
            // url = `/konto/moje-zapytania/rfp/${state.RfpId}`;
            title = "Zainteresowane firmy";
        }
        if (component === "BuyerExpressOrderDetails") {
            url = `/konto/moje-zapytania/order/${state.id}`;
            title = "Szczeg\xf3ły rezerwacji";
        }
        if (component === "BuyerProfile") {
            url = "/konto/moje-zapytania/profil";
            title = "Moje zapytania";
        }
        if (component === "BuyerAppProfile") {
            url = "/konto/buyer-app-profile";
            title = "Profil";
        }
        if (component === "RfpChatCustomerInfo") {
            if (window.localStorage.getItem("isBuyerApp") === "true") url = "/buyer-app/rfp-list/rfp";
            else url = "/moje-zapytania/rfp";
            if (state.RfpId) url += `/${state.RfpId}`;
            if (state.CustomerId) url += `/${state.CustomerId}`;
            if (state.Section === "rfp-customer-info") {
                title = "Informacje o firmie";
                url += "/informacje";
            } else {
                title = "Rozmawiaj ze Specjalistą";
                url += "/czat";
            }
            // bug z przekierowaniem na liste rfp
            if (localStorage.getItem("isBuyerApp") === "true") {
                if (!state.RfpId && !state.CustomerId) window.location.href = "/buyer-app/rfp-list";
            }
        }
        if (component === "InvoicePaymentPage") {
            title = "Płatność za fakturę";
            url = `/konto/zaplac?paymentToken=${state.InvoiceId}`;
        }
        if (component === "Form") {
            title = "Formularz ofertowy";
            url = `/formularz/${state.InitialParams ? `?${state.InitialParams}` : ""}`;
        }
        if (component === "BuyerAppContestPage") {
            title = "Konkurs";
            url = "/buyer-app-contest";
        }
        if (component === "MobileBuyerAppHomepage") {
            title = "Strona gł\xf3wna";
            url = "/buyer-app/homepage";
        }
        if (component === "BuyerAppAuth") {
            title = "Logowanie";
            url = "/buyer-app/auth";
        }
        if (component === "BuyerAppAuth") {
            title = "Logowanie";
            url = "/buyer-app/mobile-auth";
        }
        if (component === "ReviewFormPage") title = "Dodaj opinię o specjaliście";
        return {
            url: url,
            title: title
        };
    }
    async Logout() {
        // LoggedAs ustawiane jest w ServerManager.ts
        const userStore = (0, $2z5fq.useUserStore)();
        await fetch(userStore.loggedAs ? "/j_acegi_exit_user" : "/j_acegi_logout");
        document.location.href = "/";
    }
    ChangeWindowTitle(title, url) {
        if (title && title !== "Zapytanie ofertowe") document.title = `${title} – Oferteo.pl`;
        if (url) {
            let i = this.InternalStack.length;
            i = i ? i - 1 : 0;
            window.history.replaceState(this.InternalStack[i], "", url);
        }
    }
    PeekAndReplace(replacer, deep = -1) {
        const d = this.InternalStack.length - deep;
        const r = this.InternalStack[d];
        if (r) this.InternalStack[d] = replacer(r);
    }
    Peek(deep = -1) {
        try {
            let r = this.InternalStack[this.InternalStack.length - deep];
            if (!r) return null;
            r = r.indexOf("|") === -1 ? [
                r,
                "{}"
            ] : r.split("|");
            return {
                Name: r[0],
                State: JSON.parse(r[1])
            };
        } catch (err) {
            return {};
        }
    }
    ShouldScrollTop(n, p) {
        if (n.Name) return true;
        if (p) {
            if (n.State.Section !== -1 && p.State.Section && p.State.Section !== n.State.Section) return true;
            if (p.State.RfpId !== n.State.RfpId) return true;
            if (p.Name && n.Name && p.Name !== n.Name) return true;
        }
        return false;
    }
    Previous(deep = 1) {
        const internal = this.InternalStack;
        const previous = internal[internal.length - 1 - deep];
        if (!previous) return {};
        const previousState = previous.split("|")[1];
        if (!previousState) return {};
        try {
            return JSON.parse(previousState);
        } catch (err) {
            return {};
        }
    }
    Append(state, replace = false) {
        this.Travel(null, {
            ...this.CurrentState.state,
            ...state
        }, replace);
    }
    BeforeTravel(component, state, replace) {
        const prev = this.Previous();
        const current = this.CurrentState;
        const differentSection = state && current.state && current.state.Section !== state.Section;
        const travel = replace !== "fromHistory";
        const shouldDisplaySaveChanges = prev.DataShouldSubmit && current.PageComponent === "CustomerProfileView" && (component !== "CustomerProfileView" || differentSection) && travel;
        const cropPhotoModal = state && state.CropPhotoModal || prev && prev.CropPhotoModal;
        const workHoursDialog = state && state.workHoursDialog || prev && prev.workHoursDialog;
        if (shouldDisplaySaveChanges && !this.TravelTarget && !cropPhotoModal && !workHoursDialog) {
            this.TravelTarget = [
                ...arguments
            ];
            window.history.back();
            return false;
        }
        if (replace === "history" && state && state.DataShouldSubmit === true) this.DataShouldSubmitCounter++;
        if (this.DataShouldSubmitCounter > 1) {
            this.DataShouldSubmitCounter = 0;
            if (this.TravelTarget) {
                this.TravelTarget[1].DataShouldSubmit = false;
                this.Travel(this.TravelTarget[0], this.TravelTarget[1], true);
            }
            return false;
        }
        return true;
    }
    Act(action, module, newWindow) {
        const isPublic = module !== "CustomerView"; // TODO: Będzie trzeba rozwiązać kwestię przechodzenia pomiędzy modułami.
        switch(action){
            case "HomePage":
                document.location.href = "/";
                break;
            case "MobileBuyerAppHomepage":
                document.location.href = "/buyer-app/homepage";
                break;
            case "NewForm":
                document.location.href = "/znajdz-specjalistow";
                break;
            case "Rfps":
                if (isPublic) document.location.href = "/konto/zapytania";
                else this.Travel("Rfps");
                break;
            case "Contacts":
                if (isPublic) document.location.href = "/konto/kontakty";
                else this.Travel("Contacts");
                break;
            case "Scheduler":
                this.Travel("Scheduler");
                break;
            case "Services":
                document.location.href = "/konto/profil/uslugi-produkty";
                break;
            case "Promotion":
                document.location.href = "/konto/profil/promowanie";
                break;
            case "MyRfps":
                document.location.href = "/rfp/moje-zapytania.ofer";
                break;
            case "BuyerView":
                document.location.href = "/rfp/moje-zapytania.ofer";
                break;
            case "CustomerView":
                document.location.href = "/konto/";
                break;
            case "Payments":
                if (isPublic) document.location.href = "/konto/ustawienia/saldo";
                else this.Travel("Settings");
                break;
            case "ReportError":
                document.location.href = "/kontakt.html?idSubject=contactError";
                break;
            case "Partnership":
                document.location.href = "/konto/profil/program-partnerski";
                break;
            case "Register":
                document.location.href = "/rejestracja/wybierz-klientow";
                break;
            case "SetUserData":
                document.location.href = "/rfp/dane-kontaktowe.ofer";
                break;
            case "SetPassword":
                document.location.href = "/rfp/ustaw-haslo.ofer";
                break;
            case "DisplayNps":
                window.setTimeout(()=>{
                    this.Travel(null, {
                        ...this.CurrentState,
                        NpsSurveyPage: "Hello"
                    });
                }, 150);
                break;
            case "DisplayAppSurvey":
                window.setTimeout(()=>{
                    this.Append({
                        AppSurveyPage: "Hello"
                    });
                }, 150);
                break;
            case "Logout":
                this.Logout();
                break;
            default:
                if (newWindow) window.open(action);
                else document.location.href = action;
        }
    }
    GoToAutenti() {
        this.EntryUrl = document.location.pathname;
        const onboardingStore = (0, $4FjZA.useCustomerOnboardingStore)();
        onboardingStore.needsVerification = true;
        this.Travel("OnboardingPage");
    }
    Travel(component, state = {}, replace = false, options = {}) {
        if (!this.BeforeTravel(...arguments)) return;
        let goTo = "";
        if (component === "HomePage") goTo = "/";
        if (component === "HomePageBuyerApp") goTo = "/?oferteoBuyerApp=true";
        if (component === "Services") goTo = "/konto/profil/uslugi-produkty";
        if (goTo) {
            document.location.href = goTo;
            return;
        }
        // dont use replace, use options
        if (replace === "stay-scroll" && state.Scroll) window.setTimeout(()=>{
            window.scrollTo(0, state.Scroll);
        }, 150);
        else if (replace !== "history") {
            const shouldScroll = this.ShouldScrollTop({
                Name: component,
                State: state
            }, this.Peek());
            if (shouldScroll) window.scrollTo(0, 0);
        } else if (state.Scroll) // State ma scrolla.
        {
            if ((this.CurrentState.state || {}).RfpId && !state.RfpId && [
                "Rfps",
                "Contacts"
            ].indexOf(component) > -1) window.setTimeout(()=>{
                window.scroll(0, state.Scroll);
            }, 150);
        }
        if (!component) component = this.CurrentStateName;
        const historyMethod = replace ? "replaceState" : "pushState";
        const url = component + (Object.keys(state).length ? `|${JSON.stringify(state)}` : "");
        let defaults = this.Defaults[component];
        if (!defaults) defaults = {
            PageComponent: component
        };
        this.CurrentState = {
            ...defaults,
            state: state
        };
        this.CurrentStateName = component;
        const toUrl = this.ToUrl(component, state);
        if (toUrl.url.endsWith("_")) options.PreventUrlChange = true;
        // obejscie dla buga zwiazanego z brakiem przekierowanai na poprzednia strone po odswiezeniu
        if (toUrl.url.indexOf("/konto/moje-zapytania/rfp/undefined") > -1) window.location.href = "/konto/moje-zapytania";
        // obejscie dla buga zwiazanego z brakiem przekierowanai na poprzednia strone po potwierdzeniu zapytania
        if (toUrl.url.indexOf("/buyer-app/rfp-list/rfp/undefined") > -1) window.location.href = "/buyer-app/rfp-list";
        // Aby uniknąć konfliktu podczas przemieszczania się na strony korzystające z Vue Routera:
        // w innym przypadku po kliknięciu przycisku wstecz w przeglądarce następuje jeden pusty przebieg,
        // ponieważ wykonujemy dodatkowy przeskok w kontruktorze tej klasy.
        const toVueRouter = component === "CustomerProfileView" && (state.Section === "Services" || state.Section === "Promotion") || component === "ReviewFormPage";
        if (!toVueRouter) window.history[historyMethod](url, "", options.PreventUrlChange ? "" : toUrl.url);
        if (toUrl.url !== this.PreviousUrl) {
            this.SetContentGroup(component, state, toUrl.url);
            this.PreviousUrl = toUrl.url;
        }
        this.CurrentUrl = toUrl.url;
        window.setTimeout(()=>{
            this.ChangeWindowTitle(toUrl.title);
        }, 150);
        if (replace) {
            let i = this.InternalStack.length;
            i = i ? i - 1 : 0;
            this.InternalStack[i] = url;
        } else this.InternalStack.push(url);
    }
    SetContentGroup(component, state, url) {
        if (!window.Analytics) return;
        // Wyślij typ strony do analityki.
        const gtmPageType = window.Analytics.GtmPageType(window.MODULE, component, state);
        const isBuyerApp = window.localStorage.getItem("isBuyerApp") === "true";
        window.Analytics.GtmDims({
            page_type: gtmPageType,
            is_buyer_app: isBuyerApp
        });
        if (state.RfpId) return;
         // TODO: Dane z podglądu zapytania (czyl jeśli istnieje RfpId) powinny być obsługiwane w RfpDetails, bo nie mamy części informacji.
        let pageType = "";
        if (component === "Rfps") pageType = "RfpSearchMyOferteo";
        if (component === "Contacts") pageType = "ContactsMyOferteo";
        if (component === "CustomerProfileView") pageType = "ProfileMyOferteo";
        if (component === "CustomerSettingsView") pageType = "SettingsMyOferteo";
        if (component === "LoginRegister") pageType = "CustRegSearchCat";
        if (component === "Form") pageType = "RfpFormModal";
    }
    Back() {
        // Łatka przy w chodzeniu z maila, do poprawy.
        const ref = document.referrer;
        if (ref && ref.indexOf("?popros-o-opinie") > -1 && this.InternalStack.length === 1) document.location.href = "/konto/profil/";
        else if (this.InternalStack.length === 1) this.Travel(null, {});
        else window.history.back();
    }
    constructor(url, module){
        this.TravelAction = "";
        this.BaseUrl = "/konto";
        this.CurrentState = {
            PageComponent: "Rfp",
            state: {
                isAdmin: false,
                companyId: 0
            }
        };
        this.InternalStack = [];
        this.CurrentStateName = "";
        this.EntryUrl = "";
        this.CurrentUrl = "";
        this.EntryQueryUrl = "";
        this.EntryQuery = "";
        this.TravelTarget = null;
        this.DataShouldSubmitCounter = 0;
        this.ProfileSections = {
            Internal: [
                "BasicInfo",
                "ContactInfo",
                "Gallery",
                "Description",
                "Services",
                "AdditionalServices",
                "Promotion",
                "Reviews",
                "Offers",
                "Certificates",
                "Partnership"
            ],
            External: [
                "informacje",
                "dane-kontaktowe",
                "galeria-zdjec",
                "opis",
                "uslugi-produkty",
                "uslugi-dodatkowe",
                "promowanie",
                "opinie",
                "oferty",
                "certyfikaty",
                "program-partnerski"
            ],
            Label: [
                "Informacje",
                "Dane kontaktowe",
                "Galeria zdjęć",
                "Opis",
                "Usługi i produkty",
                "Usługi dodatkowe",
                "Opinie",
                "Oferty",
                "Certyfikaty",
                "Program partnerski"
            ]
        };
        this.SettingsSections = {
            Internal: [
                "Payments",
                "Notifications",
                "ChangePassword",
                "ExpressManageCustomers"
            ],
            External: [
                "saldo",
                "powiadomienia",
                "haslo",
                "admin"
            ],
            Label: [
                "Saldo",
                "Powiadomienia",
                "Ustawienia konta",
                "Zarządzanie"
            ]
        };
        this.PreviousUrl = "";
        this.Defaults = {
            MobileBuyerAppPanel: {
                PageComponent: "MobileBuyerAppPanel"
            },
            Rfps: {
                PageComponent: "RfpPage",
                List: "Rfps"
            },
            Contacts: {
                PageComponent: "RfpPage",
                List: "Contacts"
            },
            Profile: {
                PageComponent: "CustomerProfileView",
                Section: ""
            },
            Services: {
                PageComponent: "CustomerProfileView",
                Section: "Services"
            },
            Settings: {
                PageComponent: "CustomerSettingsView"
            }
        };
        this.EntryUrl = document.location.pathname;
        this.EntryQueryUrl = document.location.search;
        if (this.EntryQueryUrl.indexOf("utm_campaign=IntLinks") > -1) this.EntryUrl = this.EntryUrl.replace("/rfp/", "/konto/zapytanie/");
        const entry = this.FromUrl(url || this.EntryUrl);
        let shouldReplace = false;
        if (document.referrer && entry.component === "PublicView") // Jeżeli przechodzimy z publicznej listę zleceń, to zamień wpis w historii,
        // zamiast dodawać nowy. Ale jeżeli nie ma referera, to dodaj - żeby obsłużyć
        // przeglądarkowy przycisk cofnij. Robię to tylko dla publicznej listy - tam
        // najczęściej występują problemy.
        shouldReplace = true;
        // TODO: Powinno być replaceState, a nie pushState! Generuje to dużo bugów w momencie, kiedy stronie jest pierwsza.
        this.Travel(entry.component || "", entry.state || {}, shouldReplace, {
            PreventUrlChange: true
        });
        if (entry.component === "LoginRegister") {
            const metaDescription = document.createElement("meta");
            metaDescription.setAttribute("name", "description");
            metaDescription.setAttribute("content", "Dostarczymy Ci nowych Klient\xf3w. Określ jaką usługę lub produkt oferujesz Klientom, a my skierujemy do Ciebie osoby, kt\xf3re właśnie w tym momencie ich szukają.");
            document.head.appendChild(metaDescription);
        }
    }
}

});

parcelRequire.register("aaBFb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2eb4804289f4c9fb$export$2e2bcd8739ae039; });

var $7eFUb = parcelRequire("7eFUb");

var $lJLdg = parcelRequire("lJLdg");
class $2eb4804289f4c9fb$export$2e2bcd8739ae039 {
    TokenRefresh() {
        console.log("TokenRefresh");
    }
    async AskAndSubscribePush(userId, frontEndDebug = false) {
        const appType = await (0, $lJLdg.getAppType)();
        if (appType === "default") {
            if (!this.Messaging) {
                window.setTimeout(()=>{
                    this.AskAndSubscribePush(userId, frontEndDebug);
                }, 1500);
                return;
            }
            this.Dim("show");
            try {
                if (frontEndDebug) alert("AskAndSubscribePush userId:" + userId);
                if (this.Messaging && typeof this.Messaging.requestPermission !== "undefined") try {
                    await this.Messaging.requestPermission();
                    this.Dim("hide");
                } catch (err) {
                    this.Dim("hide");
                }
                else if (frontEndDebug) alert("Request permission method is undefined");
                this.Dim("hide");
            } catch (err) {
                this.Dim("hide");
                console.warn("Zgoda na powiadomienia nie została udzielona");
            }
        }
    }
    Dim(method = "show") {
        document.querySelector(".is-dimmed").style.display = method === "show" ? "block" : "none";
    }
    async SubscribeUserPushToken(userId, token) {
        const appType = await (0, $lJLdg.getAppType)();
        const url = `/push/json/subscribe.ofer?userPushToken.idUser=${userId}&userPushToken.token=${token}&userPushToken.deviceData=${(0, $7eFUb.getDeviceData)()}&userPushToken.agent=${(0, $7eFUb.getUserAgent)()}&userPushToken.deviceType=${(0, $7eFUb.getDeviceType)()}&userPushToken.appType=${appType}`;
        await fetch(url);
    }
    async EmptyToken(userId) {
        const appType = await (0, $lJLdg.getAppType)();
        const url = `/push/json/emptyToken.ofer?userPushToken.idUser=${userId}&userPushToken.deviceData=${(0, $7eFUb.getDeviceData)()}&userPushToken.agent=${(0, $7eFUb.getUserAgent)()}&userPushToken.deviceType=${(0, $7eFUb.getDeviceType)()}&userPushToken.appType=${appType}`;
        await fetch(url);
    }
    async GetToken(userId, frontEndDebug = false) {
        //console.log("GetToken userId:" + userId + ", frontEndDebug:" + frontEndDebug + " START");
        if (frontEndDebug) alert("GetToken userId:" + userId);
        // get Token from mobileApp
        if (typeof getFCMtoken !== "undefined") {
            if (frontEndDebug) alert("getFCMtoken != undefined");
            this.Token = await getFCMtoken();
            if (frontEndDebug) alert("this.Token:" + this.Token);
            if (this.Token) {
                if (frontEndDebug) alert("SubscribeUserPushToken userId:" + userId + ", this.Token:" + this.Token);
                await this.SubscribeUserPushToken(userId, this.Token);
                if (frontEndDebug) alert("SubscribeUserPushToken ok");
                return this.Token;
            } else await this.EmptyToken(userId);
        }
        if (frontEndDebug) alert("this.Token:" + this.Token);
        // get token from browser
        if (!this.Token) {
            if (frontEndDebug) alert("Notification.permission:" + Notification.permission);
            if (Notification.permission === "granted") {
                if (!this.Messaging.publicVapidKey) {
                    const config = this.GetConfig();
                    this.Messaging.usePublicVapidKey(config.publicVapidKey);
                }
                if (frontEndDebug) alert("this.Messaging.getToken() START");
                await this.Messaging.getToken().then(async (token)=>{
                    if (frontEndDebug) alert("this.Messaging.getToken() token:" + token);
                    if (token) {
                        this.Token = token;
                        await this.SubscribeUserPushToken(userId, token);
                    } else console.warn("GetToken(), No token available from Messaging.getToken()");
                }).catch((err)=>{
                    console.warn("GetToken(), Error retrieving token from Messaging.getToken()", err);
                });
                if (frontEndDebug) alert("this.Messaging.getToken() END");
            }
        }
    //console.log("GetToken userId:" + userId + ", frontEndDebug:" + frontEndDebug + " END");
    }
    GetConfig() {
        const url = document.location.href;
        for(const c in this.Config){
            if (url.indexOf(c) > -1) return this.Config[c];
        }
        return this.Config["oferteo-tst.pl"];
    }
    constructor(userId, frontEndDebug = false, appType, url = ""){
        this.Config = {
            "oferteo.pl": {
                apiKey: "AIzaSyCPIOzjsNBTXzmgNmjV41dIIhGR6lmZGTE",
                authDomain: "oferteopwa.firebaseapp.com",
                databaseURL: "https://oferteopwa.firebaseio.com",
                projectId: "oferteopwa",
                storageBucket: "oferteopwa.appspot.com",
                messagingSenderId: "505189348914",
                publicVapidKey: "BOXnP8hBtVcFj3jDeHhe6eIZKAqa-YRK9UOfW2LThs6g7eYCP5ia0LG6GkGf-UzPRW786eyIbw2PHWp2cQdjxbI"
            },
            "oferteo-fix.pl": {
                apiKey: "AIzaSyBHLzbAeVwjokJXBFl61knRYQ7pv893fKY",
                authDomain: "oferteopwa-fix.firebaseapp.com",
                databaseURL: "https://oferteopwa-fix.firebaseio.com",
                projectId: "oferteopwa-fix",
                storageBucket: "oferteopwa-fix.appspot.com",
                messagingSenderId: "242949374194",
                publicVapidKey: "BISA7abLkbtAK85mjyk3WYXVcSVFLwa5tK9vt0c8H8wp9ctKLTrsugHDlgq_eCcGnZ3gOvc_1FH0OC_ZknEj37U"
            },
            "oferteo-pre.pl": {
                apiKey: "AIzaSyABNKSendiJkq8XRMY7az_4zGwHPUHk_UU",
                authDomain: "oferteopwa-pre.firebaseapp.com",
                databaseURL: "https://oferteopwa-pre.firebaseio.com",
                projectId: "oferteopwa-pre",
                storageBucket: "oferteopwa-pre.appspot.com",
                messagingSenderId: "444975520293",
                publicVapidKey: "BMHjzqkOFT6hPn4pm8RyAsrA9xIjTm76TErsYGrCTyBsRnj7gkLx9tJkyENYnBOPIsoRZlehcyeoPZRESSAQyUw"
            },
            "oferteo-tst.pl": {
                apiKey: "AIzaSyDugS-zU2J95K-f_DAS5Rl44gsG22VCxIs",
                authDomain: "oferteopwa-tst.firebaseapp.com",
                databaseURL: "https://oferteopwa-tst.firebaseio.com",
                projectId: "oferteopwa-tst",
                storageBucket: "oferteopwa-tst.appspot.com",
                messagingSenderId: "443008201541",
                publicVapidKey: "BF0C9TZFevkVBSbxdFcKyGvyuzCiFhNzdlD0Dh0bJ4Yc_oOHtHWU1Qhu6mXeV5ltowQVmQDfmWAMyS-eJz2v1Cw"
            },
            "oferteo-dev.pl": {
                apiKey: "AIzaSyDMOqylp0JnoUDGHmH4CnnWDXOnYKSB-gQ",
                authDomain: "oferteopwa-dev.firebaseapp.com",
                databaseURL: "https://oferteopwa-dev.firebaseio.com",
                projectId: "oferteopwa-dev",
                storageBucket: "oferteopwa-dev.appspot.com",
                messagingSenderId: "518826271146",
                publicVapidKey: "BHrbBNyJTFOuc_wNCnSQ3zqJ69oKszUYRfVtyyGNKGK5x_VetY_IxDfi0toPrTgt5XYwlte8nhtM-5wMU-M-b6s"
            }
        };
        this.Messaging = null;
        this.UserId = null;
        this.Token = null;
        this.App = null;
        this.RequestPermissionCallback = null;
        frontEndDebug = false;
        //console.log("constructor PushNotifications userId:" + userId + ", frontEndDebug:" + frontEndDebug, + ", url:" + url);
        const config = this.GetConfig();
        this.UserId = userId;
        window.setTimeout(()=>{
            try {
                if (appType === "default") {
                    if (!firebase.apps.length) firebase.initializeApp(config);
                    this.Messaging = firebase.messaging();
                }
                this.GetToken(this.UserId, frontEndDebug);
            } catch (err) {
                console.warn(err);
            }
        }, 100);
    }
}

});

parcelRequire.register("leP4f", function(module, exports) {



















module.exports = Promise.all([
    import("./" + (parcelRequire("l0sc7")).resolve("2jMlB")),
    import("./" + (parcelRequire("l0sc7")).resolve("5XWWk")),
    import("./" + (parcelRequire("l0sc7")).resolve("cAEk6")),
    import("./" + (parcelRequire("l0sc7")).resolve("5VF7v")),
    import("./" + (parcelRequire("l0sc7")).resolve("iHsNx")),
    import("./" + (parcelRequire("l0sc7")).resolve("3gaGm")),
    import("./" + (parcelRequire("l0sc7")).resolve("3vti8")),
    (parcelRequire("fkHR7"))(new URL((parcelRequire("l0sc7")).resolve("vqybO"), import.meta.url).toString()),
    import("./" + (parcelRequire("l0sc7")).resolve("9qAXE")),
    (parcelRequire("fkHR7"))(new URL((parcelRequire("l0sc7")).resolve("iS0aj"), import.meta.url).toString()),
    import("./" + (parcelRequire("l0sc7")).resolve("18fiq")),
    (parcelRequire("fkHR7"))(new URL((parcelRequire("l0sc7")).resolve("cxETT"), import.meta.url).toString()),
    import("./" + (parcelRequire("l0sc7")).resolve("dDupD")),
    (parcelRequire("fkHR7"))(new URL((parcelRequire("l0sc7")).resolve("5K8rR"), import.meta.url).toString()),
    import("./" + (parcelRequire("l0sc7")).resolve("k3duo"))
]).then(()=>parcelRequire("XfnGr"));

});

parcelRequire.register("39vVW", function(module, exports) {
















module.exports = Promise.all([
    import("./" + (parcelRequire("l0sc7")).resolve("5XWWk")),
    import("./" + (parcelRequire("l0sc7")).resolve("cAEk6")),
    import("./" + (parcelRequire("l0sc7")).resolve("5VF7v")),
    (parcelRequire("fkHR7"))(new URL((parcelRequire("l0sc7")).resolve("5K8rR"), import.meta.url).toString()),
    import("./" + (parcelRequire("l0sc7")).resolve("3gaGm")),
    import("./" + (parcelRequire("l0sc7")).resolve("3vti8")),
    (parcelRequire("fkHR7"))(new URL((parcelRequire("l0sc7")).resolve("iS0aj"), import.meta.url).toString()),
    import("./" + (parcelRequire("l0sc7")).resolve("18fiq")),
    (parcelRequire("fkHR7"))(new URL((parcelRequire("l0sc7")).resolve("cxETT"), import.meta.url).toString()),
    import("./" + (parcelRequire("l0sc7")).resolve("dDupD")),
    (parcelRequire("fkHR7"))(new URL((parcelRequire("l0sc7")).resolve("dh8JU"), import.meta.url).toString()),
    import("./" + (parcelRequire("l0sc7")).resolve("aremp"))
]).then(()=>parcelRequire("lQGEg"));

});

parcelRequire.register("4HY1I", function(module, exports) {

module.exports = import("./" + (parcelRequire("l0sc7")).resolve("5VWh6")).then(()=>parcelRequire("9WBqu"));

});

parcelRequire.register("7pwHo", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("fkHR7"))(new URL((parcelRequire("l0sc7")).resolve("fwr7J"), import.meta.url).toString()),
    import("./" + (parcelRequire("l0sc7")).resolve("6y31q"))
]).then(()=>parcelRequire("cOtLD"));

});

parcelRequire.register("e2TzR", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("fkHR7"))(new URL((parcelRequire("l0sc7")).resolve("ghfBM"), import.meta.url).toString()),
    import("./" + (parcelRequire("l0sc7")).resolve("78UsH")),
    (parcelRequire("fkHR7"))(new URL((parcelRequire("l0sc7")).resolve("gz2Zf"), import.meta.url).toString()),
    import("./" + (parcelRequire("l0sc7")).resolve("p9bMT"))
]).then(()=>parcelRequire("cF49A"));

});

parcelRequire.register("3imCh", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("fkHR7"))(new URL((parcelRequire("l0sc7")).resolve("dMUE4"), import.meta.url).toString()),
    import("./" + (parcelRequire("l0sc7")).resolve("elaCf"))
]).then(()=>parcelRequire("b6tWe"));

});

parcelRequire.register("h31e4", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("fkHR7"))(new URL((parcelRequire("l0sc7")).resolve("jlT4y"), import.meta.url).toString()),
    import("./" + (parcelRequire("l0sc7")).resolve("9h6zi"))
]).then(()=>parcelRequire("cmTV2"));

});

parcelRequire.register("dwh9B", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("fkHR7"))(new URL((parcelRequire("l0sc7")).resolve("7Ffnp"), import.meta.url).toString()),
    import("./" + (parcelRequire("l0sc7")).resolve("5ZtVn"))
]).then(()=>parcelRequire("eR7Xj"));

});

parcelRequire.register("69Wm8", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("l0sc7")).resolve("leBBd")),
    import("./" + (parcelRequire("l0sc7")).resolve("jwFzP"))
]).then(()=>parcelRequire("13g9e"));

});

parcelRequire.register("9tANg", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("fkHR7"))(new URL((parcelRequire("l0sc7")).resolve("dN9bw"), import.meta.url).toString()),
    import("./" + (parcelRequire("l0sc7")).resolve("fDgcl"))
]).then(()=>parcelRequire("1JQEv"));

});

parcelRequire.register("1O0sq", function(module, exports) {








module.exports = Promise.all([
    import("./" + (parcelRequire("l0sc7")).resolve("iHsNx")),
    (parcelRequire("fkHR7"))(new URL((parcelRequire("l0sc7")).resolve("5K8rR"), import.meta.url).toString()),
    import("./" + (parcelRequire("l0sc7")).resolve("3gaGm")),
    import("./" + (parcelRequire("l0sc7")).resolve("3vti8")),
    (parcelRequire("fkHR7"))(new URL((parcelRequire("l0sc7")).resolve("6Ga63"), import.meta.url).toString()),
    import("./" + (parcelRequire("l0sc7")).resolve("65B4a"))
]).then(()=>parcelRequire("gX3g8"));

});


parcelRequire.register("3xYCa", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $295378f11278d794$export$b3890eb0ae9dca99; });

var $iIzY2 = parcelRequire("iIzY2");
const $295378f11278d794$var$_hoisted_1 = {
    "data-component": "BaseApp.vue"
};
const $295378f11278d794$var$_hoisted_2 = /*#__PURE__*/ (0, $iIzY2.createElementVNode)("div", {
    class: "lds-ellipsis"
}, [
    /*#__PURE__*/ (0, $iIzY2.createElementVNode)("div"),
    /*#__PURE__*/ (0, $iIzY2.createElementVNode)("div"),
    /*#__PURE__*/ (0, $iIzY2.createElementVNode)("div"),
    /*#__PURE__*/ (0, $iIzY2.createElementVNode)("div")
], -1);
const $295378f11278d794$var$_hoisted_3 = [
    $295378f11278d794$var$_hoisted_2
];
const $295378f11278d794$var$_hoisted_4 = {
    key: 2
};
const $295378f11278d794$var$_hoisted_5 = {
    key: 3,
    class: "fixed bottom-0 left-0 p-2 m-2 text-black z-64 bg-warn",
    style: {
        "display": "block !important"
    }
};
function $295378f11278d794$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_WebsocketsElement = (0, $iIzY2.resolveComponent)("WebsocketsElement");
    const _component_ToasterElement = (0, $iIzY2.resolveComponent)("ToasterElement");
    const _component_PwaDialog = (0, $iIzY2.resolveComponent)("PwaDialog");
    const _component_UnusedCatsDialog = (0, $iIzY2.resolveComponent)("UnusedCatsDialog");
    return (0, $iIzY2.openBlock)(), (0, $iIzY2.createElementBlock)("div", $295378f11278d794$var$_hoisted_1, [
        (0, $iIzY2.createElementVNode)("div", {
            class: "is-dimmed | md:fixed md:z-[4096] md:inset-0 md:backdrop-blur-sm md:g-black/25",
            style: {
                "display": "none"
            },
            onClick: _cache[0] || (_cache[0] = (...args)=>$options.HideDimmed && $options.HideDimmed(...args))
        }),
        ((0, $iIzY2.openBlock)(), (0, $iIzY2.createBlock)((0, $iIzY2.resolveDynamicComponent)($data.Module), {
            ref: "CurrentModule"
        }, null, 512)),
        (0, $iIzY2.createElementVNode)("div", {
            id: "preload-placeholder",
            class: (0, $iIzY2.normalizeClass)([
                "fixed z-[4096] inset-0 flex items-center justify-center bg-white/75 transition-opacity duration-300",
                $data.DisplaySavingScreen ? "opacity-100 pointer-events-all delay-150" : "opacity-0 pointer-events-none"
            ])
        }, $295378f11278d794$var$_hoisted_3, 2),
        _ctx.websocketUrl ? ((0, $iIzY2.openBlock)(), (0, $iIzY2.createBlock)(_component_WebsocketsElement, {
            key: 0,
            ref: "Websockets",
            onShowTotalChatMsgNotification: $options.ShowTotalChatMsgNotification
        }, null, 8, [
            "onShowTotalChatMsgNotification"
        ])) : (0, $iIzY2.createCommentVNode)("", true),
        (0, $iIzY2.createVNode)(_component_ToasterElement, {
            ref: "Toaster"
        }, null, 512),
        _ctx.User.CustomerId ? ((0, $iIzY2.openBlock)(), (0, $iIzY2.createBlock)(_component_PwaDialog, {
            key: 1
        })) : (0, $iIzY2.createCommentVNode)("", true),
        _ctx.State && _ctx.CurrentState.GlobalDialog ? ((0, $iIzY2.openBlock)(), (0, $iIzY2.createElementBlock)("div", $295378f11278d794$var$_hoisted_4, [
            (0, $iIzY2.createVNode)(_component_UnusedCatsDialog)
        ])) : (0, $iIzY2.createCommentVNode)("", true),
        _ctx.loggedAs ? ((0, $iIzY2.openBlock)(), (0, $iIzY2.createElementBlock)("div", $295378f11278d794$var$_hoisted_5, [
            (0, $iIzY2.createTextVNode)(" Zalogowany jako "),
            (0, $iIzY2.createElementVNode)("strong", null, (0, $iIzY2.toDisplayString)(_ctx.loggedAs), 1)
        ])) : (0, $iIzY2.createCommentVNode)("", true)
    ]);
}

});

parcelRequire.register("6QSx5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0149943b9cca1bdd$export$2e2bcd8739ae039; });
let $0149943b9cca1bdd$var$NOOP = ()=>{};
var $0149943b9cca1bdd$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire.register("fD2lp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69a0eab5474cda93$export$2e2bcd8739ae039; });

var $7eFUb = parcelRequire("7eFUb");

var $jfoP4 = parcelRequire("jfoP4");

var $2z5fq = parcelRequire("2z5fq");
class $69a0eab5474cda93$export$2e2bcd8739ae039 {
    static Create() {
        const appStore = (0, $jfoP4.useAppStore)();
        window.dataLayer = window.dataLayer || [];
        /* eslint-disable */ const disableAnalytics = navigator.userAgent.indexOf("appstore.oferteo") > -1 && window.localStorage.CordovaEnableTracking !== "yes";
        window.addEventListener("RequestTrackingEvent", (e)=>{
            window.localStorage.CordovaEnableTracking = e.detail ? "yes" : "no";
        }, false);
        if (disableAnalytics) return false;
        this.GtmInit(appStore.googleAnalyticsData);
        return true;
    }
    /**
	 * Przysyła początkowe zdarzenie z wymiarami. Nie dołączamy kodu GTM, ponieważ jest on już dołączony w pliku `index.html`.
	 * @param dims Poczatkowe wymiary przesłane w `hello.ofer` w polu `analytics`.
	 */ static GtmInit(dims = {}) {
        this.GtmDims(dims, false);
    }
    /**
	 * Wysyła zdarzenie `ga_dims` dodając lub zastępując wymiary, o ile te uległy zmianie.
	 * @param dims Dodatkowe wymiary.
	 */ static GtmDims(dims = {}, send = true) {
        const prev = JSON.stringify(this.GtmCurrentDims);
        this.GtmCurrentDims = {
            ...this.GtmCurrentDims,
            ...dims
        };
        // Wyślij wymiary, jeśli się zmieniły.
        if (prev !== JSON.stringify(this.GtmCurrentDims) && send) window.dataLayer.push({
            "event": "ga_dims",
            "event_params": this.GtmCurrentDims
        });
    }
    /**
	 * Wysyła zdarzenie o podanej nazwie.
	 * @param eventName Nazwa zdarzenia.
	 * @param eventParams Parametry zdarzenia. Jeżeli nie zostały podane, wyślij pusty obiekt.
	 */ static Gtm(eventName, eventParams = {}) {
        window.dataLayer.push({
            "event": "ga_event",
            "event_name": eventName,
            "event_params": eventParams
        });
    }
    /**
	 * Zwraca typ strony na potrzeby analityki.
	 * @param pageModule Obecny moduł (CustomerView, BuyerView, etc.)
	 * @param component Obecny komponent (Rfps, Profile, etc.)
	 * @param state Obecny stan strony
	 */ static GtmPageType(pageModule, component, state) {
        let result = pageModule;
        // • LoginRegister, MyOferteo, BuyerView: typ strony odpowiada nazwie modułu, nic nie musimy robić
        // • Admin: strony administracyjne nie powinny wysyłać analityki, nic nie musimy robić
        switch(pageModule){
            // • RfpForm: Składanie zapytania
            case "Form":
                result = "RfpForm";
                break;
            // • RfpDetails: Szczegóły na publicznej liście (w module `PublicView` mamy tylko ten widok)
            case "PublicView":
                result = "RfpDetails";
                break;
            case "CustomerView":
                result = "MyOferteo";
                // • MyOferteoRfpDetails: Szczegóły w Moim Oferteo
                // • CustomerRfpList: Lista w Moim Oferteo
                if (component === "Rfps" || component === "Contacts") result = `MyOferteoRfp${state.RfpId ? "Details" : "List"}`;
                // • MyOferteoStaticContent: Statyczna strona w Moim Oferteo
                const staticContent = [
                    "QuickPaymentsPage",
                    "RecommendationPage",
                    "PromotionPage"
                ];
                if (staticContent.includes(component)) result = "MyOferteoStaticContent";
                break;
            default:
                result = pageModule;
                break;
        }
        // Zwróć typ strony
        return result;
    }
    static Mixpanel() {}
    static PageView(url) {}
    static Event(label, group = "button", type = "click", nonInteraction = false) {}
    static GA4Event(event = "ga_event", name, { category_id: category_id, ...params } = {}) {
        var _window_dataLayer;
        const eventParams = {
            ...params
        };
        if (category_id) eventParams.category_id = typeof category_id === "string" ? parseInt(category_id) : category_id;
        (_window_dataLayer = window.dataLayer) === null || _window_dataLayer === void 0 ? void 0 : _window_dataLayer.push({
            event: event,
            event_name: name,
            ...Object.keys(eventParams).length > 0 ? {
                event_params: eventParams
            } : {}
        });
    }
    static ContentGroup(n = 1, l = "", isDimension = false) {}
    static Virtual() {}
    static Send() {}
    static MyOferteoTrack(group, label) {
        fetch(`/myoferteo/konto-json/log-myoferteo-action-stats.ofer?step=${group}&action=${label}`);
    }
    /**
	 * Wysyła informacje analityczne poprzez Websocket.
	 * Robimy to w ten sposób, aby utrzymać liczbę requestów w ryzach.
	 * @param id
	 * @param action
	 * @param step
	 * @param source
	 * @param other
	 * @returns
	 */ static Websocket(id = -1, action = "", step = "", source = "", other = {}) {
        const userStore = (0, $2z5fq.useUserStore)();
        // TODO: Przenieść do komponentu Rfp.vue
        const ws = $69a0eab5474cda93$export$2e2bcd8739ae039.Socket;
        if (!ws) return;
        const data = {
            idRfp: id,
            idCustomer: userStore.customerId,
            action: action,
            step: step,
            source: source,
            deviceType: (0, $7eFUb.default)(),
            ...other
        };
        try {
            ws.Send({
                type: "RfpTrack",
                data: data
            });
        } catch (err) {
            console.warn("WebsocketAnalytics", err);
        }
    }
}
(()=>{
    /** Ostatni stan wymiarów. */ $69a0eab5474cda93$export$2e2bcd8739ae039.GtmCurrentDims = {};
})();

});


var $iIzY2 = parcelRequire("iIzY2");

var $hDoNm = parcelRequire("hDoNm");

var $aaZJo = parcelRequire("aaZJo");

var $8M3Et = parcelRequire("8M3Et");

var $6Efpi = parcelRequire("6Efpi");

var $eG50F = parcelRequire("eG50F");

var $4NEue = parcelRequire("4NEue");

var $6Maox = parcelRequire("6Maox");

var $3Wthe = parcelRequire("3Wthe");

var $5yJKO = parcelRequire("5yJKO");

var $1YMd1 = parcelRequire("1YMd1");

const $cd61efe57ab69358$var$PromotionCart = ()=>(parcelRequire("hP7ZM"));

const $cd61efe57ab69358$var$FilterDetailsAutomatic = ()=>(parcelRequire("gfJak"));

const $cd61efe57ab69358$var$PromotionSummary = ()=>(parcelRequire("MlfZd"));
// eslint-disable-next-line no-unused-vars
const $cd61efe57ab69358$var$servicesChildGuard = (to, from, next)=>{
    if (from.name) next();
    else next("/konto/profil/uslugi-produkty");
};
const $cd61efe57ab69358$var$promotionChildGuard = (to, from, next)=>{
    if (from.name) next();
    else next("/konto/profil/promowanie");
};
const $cd61efe57ab69358$var$filterPrefix = ":filterId";
var $cd61efe57ab69358$export$2e2bcd8739ae039 = [
    {
        path: "/konto/profil/uslugi-produkty",
        name: "Services",
        component: (0, $6Efpi.default),
        // eslint-disable-next-line no-unused-vars
        beforeEnter: (to, from, next)=>{
            if (Object.keys(to.query).length) next(to.path);
            else next();
        },
        children: [
            {
                name: "FilterCreate",
                path: "dodaj",
                component: (0, $eG50F.default),
                beforeEnter: (to, from, next)=>{
                    if (from.name !== "Services") {
                        next("/konto/profil/uslugi-produkty");
                        return;
                    }
                    $cd61efe57ab69358$var$servicesChildGuard(to, from, next);
                }
            },
            {
                name: "FilterListItem",
                path: ":categoryId",
                component: (0, $4NEue.default),
                beforeEnter: $cd61efe57ab69358$var$servicesChildGuard,
                children: [
                    {
                        name: "FilterPricing",
                        path: "ceny",
                        component: (0, $1YMd1.default),
                        beforeEnter: $cd61efe57ab69358$var$servicesChildGuard
                    },
                    {
                        name: "FilterDetailsMatching",
                        path: `${$cd61efe57ab69358$var$filterPrefix}/dopasowanie`,
                        component: (0, $6Maox.default),
                        beforeEnter: $cd61efe57ab69358$var$servicesChildGuard
                    },
                    {
                        name: "FilterDetailsLocation",
                        path: `${$cd61efe57ab69358$var$filterPrefix}/lokalizacje`,
                        component: (0, $5yJKO.default),
                        beforeEnter: $cd61efe57ab69358$var$servicesChildGuard
                    },
                    {
                        name: "FilterDetailsQuick",
                        path: `${$cd61efe57ab69358$var$filterPrefix}/szybki-kontakt`,
                        component: (0, $3Wthe.default),
                        beforeEnter: $cd61efe57ab69358$var$servicesChildGuard,
                        children: [
                            {
                                name: "FilterDetailsQuickMatching",
                                path: "dopasowanie",
                                component: (0, $6Maox.default)
                            },
                            {
                                name: "FilterDetailsQuickLocation",
                                path: "lokalizacje",
                                component: (0, $5yJKO.default)
                            }
                        ]
                    },
                    {
                        name: "FilterDetailsAutomatic",
                        path: `${$cd61efe57ab69358$var$filterPrefix}/polecanie`,
                        component: $cd61efe57ab69358$var$FilterDetailsAutomatic,
                        beforeEnter: $cd61efe57ab69358$var$servicesChildGuard,
                        children: [
                            {
                                name: "FilterDetailsAutomaticMatching",
                                path: "dopasowanie",
                                component: (0, $6Maox.default)
                            },
                            {
                                name: "FilterDetailsAutomaticLocation",
                                path: "lokalizacje",
                                component: (0, $5yJKO.default)
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        path: "/konto/profil/promowanie",
        name: "PromotionProfile",
        component: (0, $8M3Et.default),
        beforeEnter: (to, from, next)=>{
            if (Object.keys(to.query).length) next(to.path);
            else next();
        },
        children: [
            {
                name: "PromotionSummary",
                path: "podsumowanie",
                component: $cd61efe57ab69358$var$PromotionSummary,
                beforeEnter: $cd61efe57ab69358$var$promotionChildGuard
            }
        ]
    },
    {
        path: "/konto/profil/uslugi-produkty/:pathMatch(.*)*",
        name: "NotFound",
        // eslint-disable-next-line no-unused-vars
        beforeEnter: (to, from, next)=>{
            // @TODO 404 page
            next("/");
        }
    }
];


const $8386a46bf1487863$var$router = (0, $aaZJo.createRouter)({
    history: (0, $aaZJo.createWebHistory)(),
    routes: (0, $cd61efe57ab69358$export$2e2bcd8739ae039)
});
var $8386a46bf1487863$export$2e2bcd8739ae039 = $8386a46bf1487863$var$router;



var $8ae267520a62b59f$exports = {};

var $bqdb3 = parcelRequire("bqdb3");

var $9uJWV = parcelRequire("9uJWV");

var $70Nzw = parcelRequire("70Nzw");

var $bpake = parcelRequire("bpake");

var $7Jmy6 = parcelRequire("7Jmy6");

var $1z124 = parcelRequire("1z124");

var $fhmfO = parcelRequire("fhmfO");

var $kuKRV = parcelRequire("kuKRV");

var $2vMjF = parcelRequire("2vMjF");

var $hj7GM = parcelRequire("hj7GM");

var $cIcvP = parcelRequire("cIcvP");

var $8Xbx8 = parcelRequire("8Xbx8");

var $5KHFg = parcelRequire("5KHFg");

var $6Adkl = parcelRequire("6Adkl");

var $fegcu = parcelRequire("fegcu");

var $bVHNn = parcelRequire("bVHNn");

var $a3OW9 = parcelRequire("a3OW9");

var $4LxF8 = parcelRequire("4LxF8");
$8ae267520a62b59f$exports = {
    "Autocomplete": $bqdb3,
    "Avatar": $9uJWV,
    "BaseIcon": $70Nzw,
    "CodeInput": $bpake,
    "DatePicker": $7Jmy6,
    "DropdownSelect": $1z124,
    "ExpansionPanel": $fhmfO,
    "FormGroup": $kuKRV,
    "FormInput": $2vMjF,
    "Loader": $hj7GM,
    "MessageBar": $cIcvP,
    "ModalDialog": $8Xbx8,
    "OferteoLogo": $5KHFg,
    "PageHeader": $6Adkl,
    "ProgressBar": $fegcu,
    "Rating": $bVHNn,
    "StarRating": $a3OW9,
    "TimePicker": $4LxF8
};


let $d09146966154c56c$var$script;



let $d09146966154c56c$var$initialize = ()=>{
    $d09146966154c56c$var$script = (parcelRequire("8tysl"));
    if ($d09146966154c56c$var$script.__esModule) $d09146966154c56c$var$script = $d09146966154c56c$var$script.default;
    $d09146966154c56c$var$script.render = (parcelRequire("3xYCa")).render;
    (parcelRequire("6QSx5")).default($d09146966154c56c$var$script);
    $d09146966154c56c$var$script.__scopeId = "data-v-c0cb50";
    $d09146966154c56c$var$script.__file = "BaseApp.vue";
};
$d09146966154c56c$var$initialize();
var $d09146966154c56c$export$2e2bcd8739ae039 = $d09146966154c56c$var$script;



var $hKH0O = parcelRequire("hKH0O");
const $b15ce666ddaab92d$var$directives = {
    "click-outside": {
        beforeMount (element, binding) {
            element.clickOutsideEvent = (event)=>{
                if (!(element === event.target || element.contains(event.target))) binding.value(event);
            };
            document.body.addEventListener("click", element.clickOutsideEvent);
        },
        beforeUnmount ({ clickOutsideEvent: clickOutsideEvent }) {
            document.body.removeEventListener("click", clickOutsideEvent);
        }
    }
};
var $b15ce666ddaab92d$export$2e2bcd8739ae039 = $b15ce666ddaab92d$var$directives;


const $a4bfd19fb0082a1c$var$setAccentColor = ()=>{
    const params = new URLSearchParams(document.location.search.substring(1));
    if (!params) return;
    const accentTypes = [];
    const [accent, intro, logo] = [
        params.get("accent"),
        params.get("intro"),
        params.get("logo")
    ];
    const styleElement = document.createElement("style");
    if (accent) {
        const hsl = (type, h, s, l)=>`--${type}: hsl(${h}, ${s}%, ${l}%);`;
        const [h, s, l] = accent.split(",");
        accentTypes.push(hsl("accent", h, s, l), hsl("accent-l", h, parseInt(s, 10) - 1, parseInt(l, 10) - 0 + 10), hsl("accent-d", h, parseInt(s, 10) - 0 + 1, parseInt(l, 10) - 10));
    }
    if (intro) {
        const declareStyleVariables = (n, c)=>{
            if (c) accentTypes.push(`--intro-${n}: #${c};`);
        };
        // eslint-disable-next-line prefer-const
        let [bg, fg, bbg, bfg] = intro.split(",");
        bfg = bfg || bg;
        bbg = bbg || fg;
        declareStyleVariables("bg", bg);
        declareStyleVariables("fg", fg);
        declareStyleVariables("b-bg", bbg);
        declareStyleVariables("b-fg", bfg);
    }
    if (logo) {
        const [url, width, height] = logo.split(",");
        styleElement.innerHTML = `.rfp-intro-header:after {width:${width || 172}px;height:${height || 48}px;background:url(${decodeURIComponent(url)}) no-repeat;content: '';display:block;background-size:contain;} .rfp-intro-header img {display: none;} `;
    }
    styleElement.innerHTML += `:root{ ${accentTypes.join("")} }`;
    document.head.appendChild(styleElement);
};
var $a4bfd19fb0082a1c$export$2e2bcd8739ae039 = $a4bfd19fb0082a1c$var$setAccentColor;



var $i7rRp = parcelRequire("i7rRp");

var $fD2lp = parcelRequire("fD2lp");
const $48f4127a64399c66$var$setWindowProperties = ()=>{
    const { href: href, search: search } = document.location;
    window.MODULE = "CustomerView";
    window.QUERY = search;
    window.Analytics = (0, $fD2lp.default);
    window.onerror = (0, $i7rRp.default);
    if (href.indexOf("/logowanie") > -1) window.MODULE = "LoginRegister";
    if (href.indexOf("/konto/rejestracja") > -1 || href.indexOf("rejestracja-dostawcy.html") > -1 || href.indexOf("/wybierz-klientow") > -1) window.MODULE = "LoginRegister";
    if (href.indexOf("/zobacz") > -1 || href.indexOf("/rfp") > -1) window.MODULE = "PublicView";
    if (href.indexOf("/moje-zapytania") > -1) window.MODULE = "BuyerView";
    if (href.indexOf("/formularz") > -1) window.MODULE = "RfpForm";
    if (href.indexOf("/buyer-app-profile") > -1) window.MODULE = "BuyerAppProfile";
};
var $48f4127a64399c66$export$2e2bcd8739ae039 = $48f4127a64399c66$var$setWindowProperties;


const $4d6df64fd2b83274$var$setCustomPrototypes = ()=>{
    Date.prototype.isLeapYear = function() {
        const fullYear = this.getFullYear();
        if ((fullYear & 3) != 0) return false;
        return fullYear % 100 !== 0 || fullYear % 400 === 0;
    };
    Date.prototype.getDayOfYear = function() {
        const dayCount = [
            0,
            31,
            59,
            90,
            120,
            151,
            181,
            212,
            243,
            273,
            304,
            334
        ];
        const mn = this.getMonth();
        const dn = this.getDate();
        let dayOfYear = dayCount[mn] + dn;
        if (mn > 1 && this.isLeapYear()) dayOfYear++;
        return dayOfYear;
    };
    Element.prototype.trigger = function(event) {
        const createdEvent = document.createEvent("HTMLEvents");
        createdEvent.initEvent(event, false, true);
        this.dispatchEvent(createdEvent);
    };
};
var $4d6df64fd2b83274$export$2e2bcd8739ae039 = $4d6df64fd2b83274$var$setCustomPrototypes;



var $i4M2z = parcelRequire("i4M2z");

var $d1MbU = parcelRequire("d1MbU");
const $491128f1b154fdee$var$pinia = (0, $hDoNm.createPinia)();
$491128f1b154fdee$var$pinia.use(({ store: store })=>{
    store.$router = (0, $iIzY2.markRaw)((0, $8386a46bf1487863$export$2e2bcd8739ae039));
});
const $491128f1b154fdee$var$app = (0, $iIzY2.createApp)((0, $d09146966154c56c$export$2e2bcd8739ae039)).use($491128f1b154fdee$var$pinia).use((0, $8386a46bf1487863$export$2e2bcd8739ae039));
$491128f1b154fdee$var$app.config.errorHandler = (0, $d1MbU.default);
(0, $a4bfd19fb0082a1c$export$2e2bcd8739ae039)();
(0, $48f4127a64399c66$export$2e2bcd8739ae039)();
(0, $4d6df64fd2b83274$export$2e2bcd8739ae039)();
for (const value of Object.values((0, (/*@__PURE__*/$parcel$interopDefault($8ae267520a62b59f$exports)))))$491128f1b154fdee$var$app.component(value.default.name, value.default);
$491128f1b154fdee$var$app.mixin((0, $hKH0O.default));
Object.keys((0, $b15ce666ddaab92d$export$2e2bcd8739ae039)).forEach((name)=>{
    $491128f1b154fdee$var$app.directive(name, (0, $b15ce666ddaab92d$export$2e2bcd8739ae039)[name]);
});
$491128f1b154fdee$var$app.mount("#app");
window.VueApp = $491128f1b154fdee$var$app;
(0, $i4M2z.default)($491128f1b154fdee$var$app);


//# sourceMappingURL=index.0d8e9d12.js.map
